// Generated from src/assets/font-svgs. Do not edit by hand.
import svg_abeezee from "@/assets/font-svgs/abeezee.svg";
import svg_abel from "@/assets/font-svgs/abel.svg";
import svg_abhaya_libre from "@/assets/font-svgs/abhaya-libre.svg";
import svg_aboreto from "@/assets/font-svgs/aboreto.svg";
import svg_abril_fatface from "@/assets/font-svgs/abril-fatface.svg";
import svg_abyssinica_sil from "@/assets/font-svgs/abyssinica-sil.svg";
import svg_aclonica from "@/assets/font-svgs/aclonica.svg";
import svg_acme from "@/assets/font-svgs/acme.svg";
import svg_actor from "@/assets/font-svgs/actor.svg";
import svg_adamina from "@/assets/font-svgs/adamina.svg";
import svg_adlam_display from "@/assets/font-svgs/adlam-display.svg";
import svg_advent_pro from "@/assets/font-svgs/advent-pro.svg";
import svg_afacad from "@/assets/font-svgs/afacad.svg";
import svg_agbalumo from "@/assets/font-svgs/agbalumo.svg";
import svg_agdasima from "@/assets/font-svgs/agdasima.svg";
import svg_aguafina_script from "@/assets/font-svgs/aguafina-script.svg";
import svg_akatab from "@/assets/font-svgs/akatab.svg";
import svg_akaya_kanadaka from "@/assets/font-svgs/akaya-kanadaka.svg";
import svg_akaya_telivigala from "@/assets/font-svgs/akaya-telivigala.svg";
import svg_akronim from "@/assets/font-svgs/akronim.svg";
import svg_akshar from "@/assets/font-svgs/akshar.svg";
import svg_aladin from "@/assets/font-svgs/aladin.svg";
import svg_alata from "@/assets/font-svgs/alata.svg";
import svg_alatsi from "@/assets/font-svgs/alatsi.svg";
import svg_albert_sans from "@/assets/font-svgs/albert-sans.svg";
import svg_aldrich from "@/assets/font-svgs/aldrich.svg";
import svg_alef from "@/assets/font-svgs/alef.svg";
import svg_alegreya_sans_sc from "@/assets/font-svgs/alegreya-sans-sc.svg";
import svg_alegreya_sans from "@/assets/font-svgs/alegreya-sans.svg";
import svg_alegreya_sc from "@/assets/font-svgs/alegreya-sc.svg";
import svg_alegreya from "@/assets/font-svgs/alegreya.svg";
import svg_aleo from "@/assets/font-svgs/aleo.svg";
import svg_alex_brush from "@/assets/font-svgs/alex-brush.svg";
import svg_alexandria from "@/assets/font-svgs/alexandria.svg";
import svg_alfa_slab_one from "@/assets/font-svgs/alfa-slab-one.svg";
import svg_alice from "@/assets/font-svgs/alice.svg";
import svg_alike_angular from "@/assets/font-svgs/alike-angular.svg";
import svg_alike from "@/assets/font-svgs/alike.svg";
import svg_alkalami from "@/assets/font-svgs/alkalami.svg";
import svg_alkatra from "@/assets/font-svgs/alkatra.svg";
import svg_allan from "@/assets/font-svgs/allan.svg";
import svg_allerta_stencil from "@/assets/font-svgs/allerta-stencil.svg";
import svg_allerta from "@/assets/font-svgs/allerta.svg";
import svg_allison from "@/assets/font-svgs/allison.svg";
import svg_allura from "@/assets/font-svgs/allura.svg";
import svg_almarai from "@/assets/font-svgs/almarai.svg";
import svg_almendra_display from "@/assets/font-svgs/almendra-display.svg";
import svg_almendra_sc from "@/assets/font-svgs/almendra-sc.svg";
import svg_almendra from "@/assets/font-svgs/almendra.svg";
import svg_alumni_sans_collegiate_one from "@/assets/font-svgs/alumni-sans-collegiate-one.svg";
import svg_alumni_sans_inline_one from "@/assets/font-svgs/alumni-sans-inline-one.svg";
import svg_alumni_sans_pinstripe from "@/assets/font-svgs/alumni-sans-pinstripe.svg";
import svg_alumni_sans from "@/assets/font-svgs/alumni-sans.svg";
import svg_amarante from "@/assets/font-svgs/amarante.svg";
import svg_amaranth from "@/assets/font-svgs/amaranth.svg";
import svg_amatic_sc from "@/assets/font-svgs/amatic-sc.svg";
import svg_amethysta from "@/assets/font-svgs/amethysta.svg";
import svg_amiko from "@/assets/font-svgs/amiko.svg";
import svg_amiri_quran from "@/assets/font-svgs/amiri-quran.svg";
import svg_amiri from "@/assets/font-svgs/amiri.svg";
import svg_amita from "@/assets/font-svgs/amita.svg";
import svg_anaheim from "@/assets/font-svgs/anaheim.svg";
import svg_andada_pro from "@/assets/font-svgs/andada-pro.svg";
import svg_andika from "@/assets/font-svgs/andika.svg";
import svg_anek_bangla from "@/assets/font-svgs/anek-bangla.svg";
import svg_anek_devanagari from "@/assets/font-svgs/anek-devanagari.svg";
import svg_anek_gujarati from "@/assets/font-svgs/anek-gujarati.svg";
import svg_anek_gurmukhi from "@/assets/font-svgs/anek-gurmukhi.svg";
import svg_anek_kannada from "@/assets/font-svgs/anek-kannada.svg";
import svg_anek_latin from "@/assets/font-svgs/anek-latin.svg";
import svg_anek_malayalam from "@/assets/font-svgs/anek-malayalam.svg";
import svg_anek_odia from "@/assets/font-svgs/anek-odia.svg";
import svg_anek_tamil from "@/assets/font-svgs/anek-tamil.svg";
import svg_anek_telugu from "@/assets/font-svgs/anek-telugu.svg";
import svg_angkor from "@/assets/font-svgs/angkor.svg";
import svg_annie_use_your_telescope from "@/assets/font-svgs/annie-use-your-telescope.svg";
import svg_anonymous_pro from "@/assets/font-svgs/anonymous-pro.svg";
import svg_antic_didone from "@/assets/font-svgs/antic-didone.svg";
import svg_antic_slab from "@/assets/font-svgs/antic-slab.svg";
import svg_antic from "@/assets/font-svgs/antic.svg";
import svg_anton from "@/assets/font-svgs/anton.svg";
import svg_antonio from "@/assets/font-svgs/antonio.svg";
import svg_anuphan from "@/assets/font-svgs/anuphan.svg";
import svg_anybody from "@/assets/font-svgs/anybody.svg";
import svg_aoboshi_one from "@/assets/font-svgs/aoboshi-one.svg";
import svg_ar_one_sans from "@/assets/font-svgs/ar-one-sans.svg";
import svg_arapey from "@/assets/font-svgs/arapey.svg";
import svg_arbutus_slab from "@/assets/font-svgs/arbutus-slab.svg";
import svg_arbutus from "@/assets/font-svgs/arbutus.svg";
import svg_architects_daughter from "@/assets/font-svgs/architects-daughter.svg";
import svg_archivo_black from "@/assets/font-svgs/archivo-black.svg";
import svg_archivo_narrow from "@/assets/font-svgs/archivo-narrow.svg";
import svg_archivo from "@/assets/font-svgs/archivo.svg";
import svg_are_you_serious from "@/assets/font-svgs/are-you-serious.svg";
import svg_aref_ruqaa_ink from "@/assets/font-svgs/aref-ruqaa-ink.svg";
import svg_aref_ruqaa from "@/assets/font-svgs/aref-ruqaa.svg";
import svg_arima from "@/assets/font-svgs/arima.svg";
import svg_arimo from "@/assets/font-svgs/arimo.svg";
import svg_arizonia from "@/assets/font-svgs/arizonia.svg";
import svg_armata from "@/assets/font-svgs/armata.svg";
import svg_arsenal from "@/assets/font-svgs/arsenal.svg";
import svg_artifika from "@/assets/font-svgs/artifika.svg";
import svg_arvo from "@/assets/font-svgs/arvo.svg";
import svg_arya from "@/assets/font-svgs/arya.svg";
import svg_asap_condensed from "@/assets/font-svgs/asap-condensed.svg";
import svg_asap from "@/assets/font-svgs/asap.svg";
import svg_asar from "@/assets/font-svgs/asar.svg";
import svg_asset from "@/assets/font-svgs/asset.svg";
import svg_assistant from "@/assets/font-svgs/assistant.svg";
import svg_astloch from "@/assets/font-svgs/astloch.svg";
import svg_asul from "@/assets/font-svgs/asul.svg";
import svg_athiti from "@/assets/font-svgs/athiti.svg";
import svg_atkinson_hyperlegible from "@/assets/font-svgs/atkinson-hyperlegible.svg";
import svg_atma from "@/assets/font-svgs/atma.svg";
import svg_atomic_age from "@/assets/font-svgs/atomic-age.svg";
import svg_aubrey from "@/assets/font-svgs/aubrey.svg";
import svg_audiowide from "@/assets/font-svgs/audiowide.svg";
import svg_autour_one from "@/assets/font-svgs/autour-one.svg";
import svg_average_sans from "@/assets/font-svgs/average-sans.svg";
import svg_average from "@/assets/font-svgs/average.svg";
import svg_averia_gruesa_libre from "@/assets/font-svgs/averia-gruesa-libre.svg";
import svg_averia_libre from "@/assets/font-svgs/averia-libre.svg";
import svg_averia_sans_libre from "@/assets/font-svgs/averia-sans-libre.svg";
import svg_averia_serif_libre from "@/assets/font-svgs/averia-serif-libre.svg";
import svg_azeret_mono from "@/assets/font-svgs/azeret-mono.svg";
import svg_b612_mono from "@/assets/font-svgs/b612-mono.svg";
import svg_b612 from "@/assets/font-svgs/b612.svg";
import svg_babylonica from "@/assets/font-svgs/babylonica.svg";
import svg_bacasime_antique from "@/assets/font-svgs/bacasime-antique.svg";
import svg_bad_script from "@/assets/font-svgs/bad-script.svg";
import svg_bagel_fat_one from "@/assets/font-svgs/bagel-fat-one.svg";
import svg_bahiana from "@/assets/font-svgs/bahiana.svg";
import svg_bahianita from "@/assets/font-svgs/bahianita.svg";
import svg_bai_jamjuree from "@/assets/font-svgs/bai-jamjuree.svg";
import svg_bakbak_one from "@/assets/font-svgs/bakbak-one.svg";
import svg_ballet from "@/assets/font-svgs/ballet.svg";
import svg_baloo_2 from "@/assets/font-svgs/baloo-2.svg";
import svg_baloo_bhai_2 from "@/assets/font-svgs/baloo-bhai-2.svg";
import svg_baloo_bhaijaan_2 from "@/assets/font-svgs/baloo-bhaijaan-2.svg";
import svg_baloo_bhaina_2 from "@/assets/font-svgs/baloo-bhaina-2.svg";
import svg_baloo_chettan_2 from "@/assets/font-svgs/baloo-chettan-2.svg";
import svg_baloo_da_2 from "@/assets/font-svgs/baloo-da-2.svg";
import svg_baloo_paaji_2 from "@/assets/font-svgs/baloo-paaji-2.svg";
import svg_baloo_tamma_2 from "@/assets/font-svgs/baloo-tamma-2.svg";
import svg_baloo_tammudu_2 from "@/assets/font-svgs/baloo-tammudu-2.svg";
import svg_baloo_thambi_2 from "@/assets/font-svgs/baloo-thambi-2.svg";
import svg_balsamiq_sans from "@/assets/font-svgs/balsamiq-sans.svg";
import svg_balthazar from "@/assets/font-svgs/balthazar.svg";
import svg_bangers from "@/assets/font-svgs/bangers.svg";
import svg_barlow_condensed from "@/assets/font-svgs/barlow-condensed.svg";
import svg_barlow_semi_condensed from "@/assets/font-svgs/barlow-semi-condensed.svg";
import svg_barlow from "@/assets/font-svgs/barlow.svg";
import svg_barriecito from "@/assets/font-svgs/barriecito.svg";
import svg_barrio from "@/assets/font-svgs/barrio.svg";
import svg_basic from "@/assets/font-svgs/basic.svg";
import svg_baskervville from "@/assets/font-svgs/baskervville.svg";
import svg_battambang from "@/assets/font-svgs/battambang.svg";
import svg_baumans from "@/assets/font-svgs/baumans.svg";
import svg_bayon from "@/assets/font-svgs/bayon.svg";
import svg_be_vietnam_pro from "@/assets/font-svgs/be-vietnam-pro.svg";
import svg_beau_rivage from "@/assets/font-svgs/beau-rivage.svg";
import svg_bebas_neue from "@/assets/font-svgs/bebas-neue.svg";
import svg_belanosima from "@/assets/font-svgs/belanosima.svg";
import svg_belgrano from "@/assets/font-svgs/belgrano.svg";
import svg_bellefair from "@/assets/font-svgs/bellefair.svg";
import svg_belleza from "@/assets/font-svgs/belleza.svg";
import svg_bellota_text from "@/assets/font-svgs/bellota-text.svg";
import svg_bellota from "@/assets/font-svgs/bellota.svg";
import svg_benchnine from "@/assets/font-svgs/benchnine.svg";
import svg_benne from "@/assets/font-svgs/benne.svg";
import svg_bentham from "@/assets/font-svgs/bentham.svg";
import svg_berkshire_swash from "@/assets/font-svgs/berkshire-swash.svg";
import svg_besley from "@/assets/font-svgs/besley.svg";
import svg_beth_ellen from "@/assets/font-svgs/beth-ellen.svg";
import svg_bevan from "@/assets/font-svgs/bevan.svg";
import svg_bhutuka_expanded_one from "@/assets/font-svgs/bhutuka-expanded-one.svg";
import svg_big_shoulders_display from "@/assets/font-svgs/big-shoulders-display.svg";
import svg_big_shoulders_inline_display from "@/assets/font-svgs/big-shoulders-inline-display.svg";
import svg_big_shoulders_inline_text from "@/assets/font-svgs/big-shoulders-inline-text.svg";
import svg_big_shoulders_stencil_display from "@/assets/font-svgs/big-shoulders-stencil-display.svg";
import svg_big_shoulders_stencil_text from "@/assets/font-svgs/big-shoulders-stencil-text.svg";
import svg_big_shoulders_text from "@/assets/font-svgs/big-shoulders-text.svg";
import svg_bigelow_rules from "@/assets/font-svgs/bigelow-rules.svg";
import svg_bigshot_one from "@/assets/font-svgs/bigshot-one.svg";
import svg_bilbo_swash_caps from "@/assets/font-svgs/bilbo-swash-caps.svg";
import svg_bilbo from "@/assets/font-svgs/bilbo.svg";
import svg_biorhyme_expanded from "@/assets/font-svgs/biorhyme-expanded.svg";
import svg_biorhyme from "@/assets/font-svgs/biorhyme.svg";
import svg_birthstone_bounce from "@/assets/font-svgs/birthstone-bounce.svg";
import svg_birthstone from "@/assets/font-svgs/birthstone.svg";
import svg_biryani from "@/assets/font-svgs/biryani.svg";
import svg_bitter from "@/assets/font-svgs/bitter.svg";
import svg_biz_udgothic from "@/assets/font-svgs/biz-udgothic.svg";
import svg_biz_udmincho from "@/assets/font-svgs/biz-udmincho.svg";
import svg_biz_udpgothic from "@/assets/font-svgs/biz-udpgothic.svg";
import svg_biz_udpmincho from "@/assets/font-svgs/biz-udpmincho.svg";
import svg_black_and_white_picture from "@/assets/font-svgs/black-and-white-picture.svg";
import svg_black_han_sans from "@/assets/font-svgs/black-han-sans.svg";
import svg_black_ops_one from "@/assets/font-svgs/black-ops-one.svg";
import svg_blaka_hollow from "@/assets/font-svgs/blaka-hollow.svg";
import svg_blaka_ink from "@/assets/font-svgs/blaka-ink.svg";
import svg_blaka from "@/assets/font-svgs/blaka.svg";
import svg_blinker from "@/assets/font-svgs/blinker.svg";
import svg_bodoni_moda from "@/assets/font-svgs/bodoni-moda.svg";
import svg_bokor from "@/assets/font-svgs/bokor.svg";
import svg_bona_nova from "@/assets/font-svgs/bona-nova.svg";
import svg_bonbon from "@/assets/font-svgs/bonbon.svg";
import svg_bonheur_royale from "@/assets/font-svgs/bonheur-royale.svg";
import svg_boogaloo from "@/assets/font-svgs/boogaloo.svg";
import svg_borel from "@/assets/font-svgs/borel.svg";
import svg_bowlby_one_sc from "@/assets/font-svgs/bowlby-one-sc.svg";
import svg_bowlby_one from "@/assets/font-svgs/bowlby-one.svg";
import svg_braah_one from "@/assets/font-svgs/braah-one.svg";
import svg_brawler from "@/assets/font-svgs/brawler.svg";
import svg_bree_serif from "@/assets/font-svgs/bree-serif.svg";
import svg_bricolage_grotesque from "@/assets/font-svgs/bricolage-grotesque.svg";
import svg_bruno_ace_sc from "@/assets/font-svgs/bruno-ace-sc.svg";
import svg_bruno_ace from "@/assets/font-svgs/bruno-ace.svg";
import svg_brygada_1918 from "@/assets/font-svgs/brygada-1918.svg";
import svg_bubblegum_sans from "@/assets/font-svgs/bubblegum-sans.svg";
import svg_bubbler_one from "@/assets/font-svgs/bubbler-one.svg";
import svg_buenard from "@/assets/font-svgs/buenard.svg";
import svg_bungee_hairline from "@/assets/font-svgs/bungee-hairline.svg";
import svg_bungee_inline from "@/assets/font-svgs/bungee-inline.svg";
import svg_bungee_outline from "@/assets/font-svgs/bungee-outline.svg";
import svg_bungee_shade from "@/assets/font-svgs/bungee-shade.svg";
import svg_bungee_spice from "@/assets/font-svgs/bungee-spice.svg";
import svg_bungee from "@/assets/font-svgs/bungee.svg";
import svg_butcherman from "@/assets/font-svgs/butcherman.svg";
import svg_butterfly_kids from "@/assets/font-svgs/butterfly-kids.svg";
import svg_cabin_condensed from "@/assets/font-svgs/cabin-condensed.svg";
import svg_cabin_sketch from "@/assets/font-svgs/cabin-sketch.svg";
import svg_cabin from "@/assets/font-svgs/cabin.svg";
import svg_caesar_dressing from "@/assets/font-svgs/caesar-dressing.svg";
import svg_cagliostro from "@/assets/font-svgs/cagliostro.svg";
import svg_cairo_play from "@/assets/font-svgs/cairo-play.svg";
import svg_cairo from "@/assets/font-svgs/cairo.svg";
import svg_caladea from "@/assets/font-svgs/caladea.svg";
import svg_calistoga from "@/assets/font-svgs/calistoga.svg";
import svg_calligraffitti from "@/assets/font-svgs/calligraffitti.svg";
import svg_cambay from "@/assets/font-svgs/cambay.svg";
import svg_cambo from "@/assets/font-svgs/cambo.svg";
import svg_candal from "@/assets/font-svgs/candal.svg";
import svg_cantarell from "@/assets/font-svgs/cantarell.svg";
import svg_cantata_one from "@/assets/font-svgs/cantata-one.svg";
import svg_cantora_one from "@/assets/font-svgs/cantora-one.svg";
import svg_caprasimo from "@/assets/font-svgs/caprasimo.svg";
import svg_capriola from "@/assets/font-svgs/capriola.svg";
import svg_caramel from "@/assets/font-svgs/caramel.svg";
import svg_carattere from "@/assets/font-svgs/carattere.svg";
import svg_cardo from "@/assets/font-svgs/cardo.svg";
import svg_carlito from "@/assets/font-svgs/carlito.svg";
import svg_carme from "@/assets/font-svgs/carme.svg";
import svg_carrois_gothic_sc from "@/assets/font-svgs/carrois-gothic-sc.svg";
import svg_carrois_gothic from "@/assets/font-svgs/carrois-gothic.svg";
import svg_carter_one from "@/assets/font-svgs/carter-one.svg";
import svg_castoro_titling from "@/assets/font-svgs/castoro-titling.svg";
import svg_castoro from "@/assets/font-svgs/castoro.svg";
import svg_catamaran from "@/assets/font-svgs/catamaran.svg";
import svg_caudex from "@/assets/font-svgs/caudex.svg";
import svg_caveat_brush from "@/assets/font-svgs/caveat-brush.svg";
import svg_caveat from "@/assets/font-svgs/caveat.svg";
import svg_cedarville_cursive from "@/assets/font-svgs/cedarville-cursive.svg";
import svg_ceviche_one from "@/assets/font-svgs/ceviche-one.svg";
import svg_chakra_petch from "@/assets/font-svgs/chakra-petch.svg";
import svg_changa_one from "@/assets/font-svgs/changa-one.svg";
import svg_changa from "@/assets/font-svgs/changa.svg";
import svg_chango from "@/assets/font-svgs/chango.svg";
import svg_charis_sil from "@/assets/font-svgs/charis-sil.svg";
import svg_charm from "@/assets/font-svgs/charm.svg";
import svg_charmonman from "@/assets/font-svgs/charmonman.svg";
import svg_chathura from "@/assets/font-svgs/chathura.svg";
import svg_chau_philomene_one from "@/assets/font-svgs/chau-philomene-one.svg";
import svg_chela_one from "@/assets/font-svgs/chela-one.svg";
import svg_chelsea_market from "@/assets/font-svgs/chelsea-market.svg";
import svg_chenla from "@/assets/font-svgs/chenla.svg";
import svg_cherish from "@/assets/font-svgs/cherish.svg";
import svg_cherry_bomb_one from "@/assets/font-svgs/cherry-bomb-one.svg";
import svg_cherry_cream_soda from "@/assets/font-svgs/cherry-cream-soda.svg";
import svg_cherry_swash from "@/assets/font-svgs/cherry-swash.svg";
import svg_chewy from "@/assets/font-svgs/chewy.svg";
import svg_chicle from "@/assets/font-svgs/chicle.svg";
import svg_chilanka from "@/assets/font-svgs/chilanka.svg";
import svg_chivo_mono from "@/assets/font-svgs/chivo-mono.svg";
import svg_chivo from "@/assets/font-svgs/chivo.svg";
import svg_chokokutai from "@/assets/font-svgs/chokokutai.svg";
import svg_chonburi from "@/assets/font-svgs/chonburi.svg";
import svg_cinzel_decorative from "@/assets/font-svgs/cinzel-decorative.svg";
import svg_cinzel from "@/assets/font-svgs/cinzel.svg";
import svg_clicker_script from "@/assets/font-svgs/clicker-script.svg";
import svg_climate_crisis from "@/assets/font-svgs/climate-crisis.svg";
import svg_coda from "@/assets/font-svgs/coda.svg";
import svg_codystar from "@/assets/font-svgs/codystar.svg";
import svg_coiny from "@/assets/font-svgs/coiny.svg";
import svg_combo from "@/assets/font-svgs/combo.svg";
import svg_comfortaa from "@/assets/font-svgs/comfortaa.svg";
import svg_comforter_brush from "@/assets/font-svgs/comforter-brush.svg";
import svg_comforter from "@/assets/font-svgs/comforter.svg";
import svg_comic_neue from "@/assets/font-svgs/comic-neue.svg";
import svg_coming_soon from "@/assets/font-svgs/coming-soon.svg";
import svg_comme from "@/assets/font-svgs/comme.svg";
import svg_commissioner from "@/assets/font-svgs/commissioner.svg";
import svg_concert_one from "@/assets/font-svgs/concert-one.svg";
import svg_condiment from "@/assets/font-svgs/condiment.svg";
import svg_content from "@/assets/font-svgs/content.svg";
import svg_contrail_one from "@/assets/font-svgs/contrail-one.svg";
import svg_convergence from "@/assets/font-svgs/convergence.svg";
import svg_cookie from "@/assets/font-svgs/cookie.svg";
import svg_copse from "@/assets/font-svgs/copse.svg";
import svg_corben from "@/assets/font-svgs/corben.svg";
import svg_corinthia from "@/assets/font-svgs/corinthia.svg";
import svg_cormorant_garamond from "@/assets/font-svgs/cormorant-garamond.svg";
import svg_cormorant_infant from "@/assets/font-svgs/cormorant-infant.svg";
import svg_cormorant_sc from "@/assets/font-svgs/cormorant-sc.svg";
import svg_cormorant_unicase from "@/assets/font-svgs/cormorant-unicase.svg";
import svg_cormorant_upright from "@/assets/font-svgs/cormorant-upright.svg";
import svg_cormorant from "@/assets/font-svgs/cormorant.svg";
import svg_courgette from "@/assets/font-svgs/courgette.svg";
import svg_courier_prime from "@/assets/font-svgs/courier-prime.svg";
import svg_cousine from "@/assets/font-svgs/cousine.svg";
import svg_coustard from "@/assets/font-svgs/coustard.svg";
import svg_covered_by_your_grace from "@/assets/font-svgs/covered-by-your-grace.svg";
import svg_crafty_girls from "@/assets/font-svgs/crafty-girls.svg";
import svg_creepster from "@/assets/font-svgs/creepster.svg";
import svg_crete_round from "@/assets/font-svgs/crete-round.svg";
import svg_crimson_pro from "@/assets/font-svgs/crimson-pro.svg";
import svg_crimson_text from "@/assets/font-svgs/crimson-text.svg";
import svg_croissant_one from "@/assets/font-svgs/croissant-one.svg";
import svg_crushed from "@/assets/font-svgs/crushed.svg";
import svg_cuprum from "@/assets/font-svgs/cuprum.svg";
import svg_cute_font from "@/assets/font-svgs/cute-font.svg";
import svg_cutive_mono from "@/assets/font-svgs/cutive-mono.svg";
import svg_cutive from "@/assets/font-svgs/cutive.svg";
import svg_dai_banna_sil from "@/assets/font-svgs/dai-banna-sil.svg";
import svg_damion from "@/assets/font-svgs/damion.svg";
import svg_dancing_script from "@/assets/font-svgs/dancing-script.svg";
import svg_dangrek from "@/assets/font-svgs/dangrek.svg";
import svg_darker_grotesque from "@/assets/font-svgs/darker-grotesque.svg";
import svg_darumadrop_one from "@/assets/font-svgs/darumadrop-one.svg";
import svg_david_libre from "@/assets/font-svgs/david-libre.svg";
import svg_dawning_of_a_new_day from "@/assets/font-svgs/dawning-of-a-new-day.svg";
import svg_days_one from "@/assets/font-svgs/days-one.svg";
import svg_dekko from "@/assets/font-svgs/dekko.svg";
import svg_dela_gothic_one from "@/assets/font-svgs/dela-gothic-one.svg";
import svg_delicious_handrawn from "@/assets/font-svgs/delicious-handrawn.svg";
import svg_delius_swash_caps from "@/assets/font-svgs/delius-swash-caps.svg";
import svg_delius_unicase from "@/assets/font-svgs/delius-unicase.svg";
import svg_delius from "@/assets/font-svgs/delius.svg";
import svg_della_respira from "@/assets/font-svgs/della-respira.svg";
import svg_denk_one from "@/assets/font-svgs/denk-one.svg";
import svg_devonshire from "@/assets/font-svgs/devonshire.svg";
import svg_dhurjati from "@/assets/font-svgs/dhurjati.svg";
import svg_didact_gothic from "@/assets/font-svgs/didact-gothic.svg";
import svg_diphylleia from "@/assets/font-svgs/diphylleia.svg";
import svg_diplomata_sc from "@/assets/font-svgs/diplomata-sc.svg";
import svg_diplomata from "@/assets/font-svgs/diplomata.svg";
import svg_dm_mono from "@/assets/font-svgs/dm-mono.svg";
import svg_dm_sans from "@/assets/font-svgs/dm-sans.svg";
import svg_dm_serif_display from "@/assets/font-svgs/dm-serif-display.svg";
import svg_dm_serif_text from "@/assets/font-svgs/dm-serif-text.svg";
import svg_do_hyeon from "@/assets/font-svgs/do-hyeon.svg";
import svg_dokdo from "@/assets/font-svgs/dokdo.svg";
import svg_domine from "@/assets/font-svgs/domine.svg";
import svg_donegal_one from "@/assets/font-svgs/donegal-one.svg";
import svg_dongle from "@/assets/font-svgs/dongle.svg";
import svg_doppio_one from "@/assets/font-svgs/doppio-one.svg";
import svg_dorsa from "@/assets/font-svgs/dorsa.svg";
import svg_dosis from "@/assets/font-svgs/dosis.svg";
import svg_dotgothic16 from "@/assets/font-svgs/dotgothic16.svg";
import svg_dr_sugiyama from "@/assets/font-svgs/dr-sugiyama.svg";
import svg_duru_sans from "@/assets/font-svgs/duru-sans.svg";
import svg_dynalight from "@/assets/font-svgs/dynalight.svg";
import svg_dynapuff from "@/assets/font-svgs/dynapuff.svg";
import svg_eagle_lake from "@/assets/font-svgs/eagle-lake.svg";
import svg_east_sea_dokdo from "@/assets/font-svgs/east-sea-dokdo.svg";
import svg_eater from "@/assets/font-svgs/eater.svg";
import svg_eb_garamond from "@/assets/font-svgs/eb-garamond.svg";
import svg_economica from "@/assets/font-svgs/economica.svg";
import svg_eczar from "@/assets/font-svgs/eczar.svg";
import svg_edu_nsw_act_foundation from "@/assets/font-svgs/edu-nsw-act-foundation.svg";
import svg_edu_qld_beginner from "@/assets/font-svgs/edu-qld-beginner.svg";
import svg_edu_sa_beginner from "@/assets/font-svgs/edu-sa-beginner.svg";
import svg_edu_tas_beginner from "@/assets/font-svgs/edu-tas-beginner.svg";
import svg_edu_vic_wa_nt_beginner from "@/assets/font-svgs/edu-vic-wa-nt-beginner.svg";
import svg_el_messiri from "@/assets/font-svgs/el-messiri.svg";
import svg_electrolize from "@/assets/font-svgs/electrolize.svg";
import svg_elsie_swash_caps from "@/assets/font-svgs/elsie-swash-caps.svg";
import svg_elsie from "@/assets/font-svgs/elsie.svg";
import svg_emblema_one from "@/assets/font-svgs/emblema-one.svg";
import svg_emilys_candy from "@/assets/font-svgs/emilys-candy.svg";
import svg_encode_sans_condensed from "@/assets/font-svgs/encode-sans-condensed.svg";
import svg_encode_sans_expanded from "@/assets/font-svgs/encode-sans-expanded.svg";
import svg_encode_sans_sc from "@/assets/font-svgs/encode-sans-sc.svg";
import svg_encode_sans_semi_condensed from "@/assets/font-svgs/encode-sans-semi-condensed.svg";
import svg_encode_sans_semi_expanded from "@/assets/font-svgs/encode-sans-semi-expanded.svg";
import svg_encode_sans from "@/assets/font-svgs/encode-sans.svg";
import svg_engagement from "@/assets/font-svgs/engagement.svg";
import svg_englebert from "@/assets/font-svgs/englebert.svg";
import svg_enriqueta from "@/assets/font-svgs/enriqueta.svg";
import svg_ephesis from "@/assets/font-svgs/ephesis.svg";
import svg_epilogue from "@/assets/font-svgs/epilogue.svg";
import svg_erica_one from "@/assets/font-svgs/erica-one.svg";
import svg_esteban from "@/assets/font-svgs/esteban.svg";
import svg_estonia from "@/assets/font-svgs/estonia.svg";
import svg_euphoria_script from "@/assets/font-svgs/euphoria-script.svg";
import svg_ewert from "@/assets/font-svgs/ewert.svg";
import svg_exo_2 from "@/assets/font-svgs/exo-2.svg";
import svg_exo from "@/assets/font-svgs/exo.svg";
import svg_expletus_sans from "@/assets/font-svgs/expletus-sans.svg";
import svg_explora from "@/assets/font-svgs/explora.svg";
import svg_fahkwang from "@/assets/font-svgs/fahkwang.svg";
import svg_familjen_grotesk from "@/assets/font-svgs/familjen-grotesk.svg";
import svg_fanwood_text from "@/assets/font-svgs/fanwood-text.svg";
import svg_farro from "@/assets/font-svgs/farro.svg";
import svg_farsan from "@/assets/font-svgs/farsan.svg";
import svg_fascinate_inline from "@/assets/font-svgs/fascinate-inline.svg";
import svg_fascinate from "@/assets/font-svgs/fascinate.svg";
import svg_faster_one from "@/assets/font-svgs/faster-one.svg";
import svg_fasthand from "@/assets/font-svgs/fasthand.svg";
import svg_fauna_one from "@/assets/font-svgs/fauna-one.svg";
import svg_faustina from "@/assets/font-svgs/faustina.svg";
import svg_federant from "@/assets/font-svgs/federant.svg";
import svg_federo from "@/assets/font-svgs/federo.svg";
import svg_felipa from "@/assets/font-svgs/felipa.svg";
import svg_fenix from "@/assets/font-svgs/fenix.svg";
import svg_festive from "@/assets/font-svgs/festive.svg";
import svg_figtree from "@/assets/font-svgs/figtree.svg";
import svg_finger_paint from "@/assets/font-svgs/finger-paint.svg";
import svg_finlandica from "@/assets/font-svgs/finlandica.svg";
import svg_fira_code from "@/assets/font-svgs/fira-code.svg";
import svg_fira_mono from "@/assets/font-svgs/fira-mono.svg";
import svg_fira_sans_condensed from "@/assets/font-svgs/fira-sans-condensed.svg";
import svg_fira_sans_extra_condensed from "@/assets/font-svgs/fira-sans-extra-condensed.svg";
import svg_fira_sans from "@/assets/font-svgs/fira-sans.svg";
import svg_fjalla_one from "@/assets/font-svgs/fjalla-one.svg";
import svg_fjord_one from "@/assets/font-svgs/fjord-one.svg";
import svg_flamenco from "@/assets/font-svgs/flamenco.svg";
import svg_flavors from "@/assets/font-svgs/flavors.svg";
import svg_fleur_de_leah from "@/assets/font-svgs/fleur-de-leah.svg";
import svg_flow_block from "@/assets/font-svgs/flow-block.svg";
import svg_flow_circular from "@/assets/font-svgs/flow-circular.svg";
import svg_flow_rounded from "@/assets/font-svgs/flow-rounded.svg";
import svg_foldit from "@/assets/font-svgs/foldit.svg";
import svg_fondamento from "@/assets/font-svgs/fondamento.svg";
import svg_fontdiner_swanky from "@/assets/font-svgs/fontdiner-swanky.svg";
import svg_forum from "@/assets/font-svgs/forum.svg";
import svg_fragment_mono from "@/assets/font-svgs/fragment-mono.svg";
import svg_francois_one from "@/assets/font-svgs/francois-one.svg";
import svg_frank_ruhl_libre from "@/assets/font-svgs/frank-ruhl-libre.svg";
import svg_fraunces from "@/assets/font-svgs/fraunces.svg";
import svg_freckle_face from "@/assets/font-svgs/freckle-face.svg";
import svg_fredericka_the_great from "@/assets/font-svgs/fredericka-the-great.svg";
import svg_fredoka from "@/assets/font-svgs/fredoka.svg";
import svg_freehand from "@/assets/font-svgs/freehand.svg";
import svg_fresca from "@/assets/font-svgs/fresca.svg";
import svg_frijole from "@/assets/font-svgs/frijole.svg";
import svg_fruktur from "@/assets/font-svgs/fruktur.svg";
import svg_fugaz_one from "@/assets/font-svgs/fugaz-one.svg";
import svg_fuggles from "@/assets/font-svgs/fuggles.svg";
import svg_fuzzy_bubbles from "@/assets/font-svgs/fuzzy-bubbles.svg";
import svg_gabarito from "@/assets/font-svgs/gabarito.svg";
import svg_gabriela from "@/assets/font-svgs/gabriela.svg";
import svg_gaegu from "@/assets/font-svgs/gaegu.svg";
import svg_gafata from "@/assets/font-svgs/gafata.svg";
import svg_gajraj_one from "@/assets/font-svgs/gajraj-one.svg";
import svg_galada from "@/assets/font-svgs/galada.svg";
import svg_galdeano from "@/assets/font-svgs/galdeano.svg";
import svg_galindo from "@/assets/font-svgs/galindo.svg";
import svg_gamja_flower from "@/assets/font-svgs/gamja-flower.svg";
import svg_gantari from "@/assets/font-svgs/gantari.svg";
import svg_gasoek_one from "@/assets/font-svgs/gasoek-one.svg";
import svg_gayathri from "@/assets/font-svgs/gayathri.svg";
import svg_gelasio from "@/assets/font-svgs/gelasio.svg";
import svg_gemunu_libre from "@/assets/font-svgs/gemunu-libre.svg";
import svg_genos from "@/assets/font-svgs/genos.svg";
import svg_gentium_book_plus from "@/assets/font-svgs/gentium-book-plus.svg";
import svg_gentium_plus from "@/assets/font-svgs/gentium-plus.svg";
import svg_geo from "@/assets/font-svgs/geo.svg";
import svg_geologica from "@/assets/font-svgs/geologica.svg";
import svg_georama from "@/assets/font-svgs/georama.svg";
import svg_geostar_fill from "@/assets/font-svgs/geostar-fill.svg";
import svg_geostar from "@/assets/font-svgs/geostar.svg";
import svg_germania_one from "@/assets/font-svgs/germania-one.svg";
import svg_gfs_didot from "@/assets/font-svgs/gfs-didot.svg";
import svg_gfs_neohellenic from "@/assets/font-svgs/gfs-neohellenic.svg";
import svg_gideon_roman from "@/assets/font-svgs/gideon-roman.svg";
import svg_gidugu from "@/assets/font-svgs/gidugu.svg";
import svg_gilda_display from "@/assets/font-svgs/gilda-display.svg";
import svg_girassol from "@/assets/font-svgs/girassol.svg";
import svg_give_you_glory from "@/assets/font-svgs/give-you-glory.svg";
import svg_glass_antiqua from "@/assets/font-svgs/glass-antiqua.svg";
import svg_glegoo from "@/assets/font-svgs/glegoo.svg";
import svg_gloock from "@/assets/font-svgs/gloock.svg";
import svg_gloria_hallelujah from "@/assets/font-svgs/gloria-hallelujah.svg";
import svg_glory from "@/assets/font-svgs/glory.svg";
import svg_gluten from "@/assets/font-svgs/gluten.svg";
import svg_goblin_one from "@/assets/font-svgs/goblin-one.svg";
import svg_gochi_hand from "@/assets/font-svgs/gochi-hand.svg";
import svg_goldman from "@/assets/font-svgs/goldman.svg";
import svg_golos_text from "@/assets/font-svgs/golos-text.svg";
import svg_gorditas from "@/assets/font-svgs/gorditas.svg";
import svg_gothic_a1 from "@/assets/font-svgs/gothic-a1.svg";
import svg_gotu from "@/assets/font-svgs/gotu.svg";
import svg_goudy_bookletter_1911 from "@/assets/font-svgs/goudy-bookletter-1911.svg";
import svg_gowun_batang from "@/assets/font-svgs/gowun-batang.svg";
import svg_gowun_dodum from "@/assets/font-svgs/gowun-dodum.svg";
import svg_graduate from "@/assets/font-svgs/graduate.svg";
import svg_grand_hotel from "@/assets/font-svgs/grand-hotel.svg";
import svg_grandiflora_one from "@/assets/font-svgs/grandiflora-one.svg";
import svg_grandstander from "@/assets/font-svgs/grandstander.svg";
import svg_grape_nuts from "@/assets/font-svgs/grape-nuts.svg";
import svg_gravitas_one from "@/assets/font-svgs/gravitas-one.svg";
import svg_great_vibes from "@/assets/font-svgs/great-vibes.svg";
import svg_grechen_fuemen from "@/assets/font-svgs/grechen-fuemen.svg";
import svg_grenze_gotisch from "@/assets/font-svgs/grenze-gotisch.svg";
import svg_grenze from "@/assets/font-svgs/grenze.svg";
import svg_grey_qo from "@/assets/font-svgs/grey-qo.svg";
import svg_griffy from "@/assets/font-svgs/griffy.svg";
import svg_gruppo from "@/assets/font-svgs/gruppo.svg";
import svg_gudea from "@/assets/font-svgs/gudea.svg";
import svg_gugi from "@/assets/font-svgs/gugi.svg";
import svg_gulzar from "@/assets/font-svgs/gulzar.svg";
import svg_gupter from "@/assets/font-svgs/gupter.svg";
import svg_gurajada from "@/assets/font-svgs/gurajada.svg";
import svg_gwendolyn from "@/assets/font-svgs/gwendolyn.svg";
import svg_habibi from "@/assets/font-svgs/habibi.svg";
import svg_hachi_maru_pop from "@/assets/font-svgs/hachi-maru-pop.svg";
import svg_hahmlet from "@/assets/font-svgs/hahmlet.svg";
import svg_halant from "@/assets/font-svgs/halant.svg";
import svg_hammersmith_one from "@/assets/font-svgs/hammersmith-one.svg";
import svg_hanalei_fill from "@/assets/font-svgs/hanalei-fill.svg";
import svg_hanalei from "@/assets/font-svgs/hanalei.svg";
import svg_handjet from "@/assets/font-svgs/handjet.svg";
import svg_handlee from "@/assets/font-svgs/handlee.svg";
import svg_hanken_grotesk from "@/assets/font-svgs/hanken-grotesk.svg";
import svg_hanuman from "@/assets/font-svgs/hanuman.svg";
import svg_happy_monkey from "@/assets/font-svgs/happy-monkey.svg";
import svg_harmattan from "@/assets/font-svgs/harmattan.svg";
import svg_headland_one from "@/assets/font-svgs/headland-one.svg";
import svg_hedvig_letters_sans from "@/assets/font-svgs/hedvig-letters-sans.svg";
import svg_hedvig_letters_serif from "@/assets/font-svgs/hedvig-letters-serif.svg";
import svg_heebo from "@/assets/font-svgs/heebo.svg";
import svg_henny_penny from "@/assets/font-svgs/henny-penny.svg";
import svg_hepta_slab from "@/assets/font-svgs/hepta-slab.svg";
import svg_herr_von_muellerhoff from "@/assets/font-svgs/herr-von-muellerhoff.svg";
import svg_hi_melody from "@/assets/font-svgs/hi-melody.svg";
import svg_hina_mincho from "@/assets/font-svgs/hina-mincho.svg";
import svg_hind_guntur from "@/assets/font-svgs/hind-guntur.svg";
import svg_hind_madurai from "@/assets/font-svgs/hind-madurai.svg";
import svg_hind_siliguri from "@/assets/font-svgs/hind-siliguri.svg";
import svg_hind_vadodara from "@/assets/font-svgs/hind-vadodara.svg";
import svg_hind from "@/assets/font-svgs/hind.svg";
import svg_holtwood_one_sc from "@/assets/font-svgs/holtwood-one-sc.svg";
import svg_homemade_apple from "@/assets/font-svgs/homemade-apple.svg";
import svg_homenaje from "@/assets/font-svgs/homenaje.svg";
import svg_hubballi from "@/assets/font-svgs/hubballi.svg";
import svg_hurricane from "@/assets/font-svgs/hurricane.svg";
import svg_ibarra_real_nova from "@/assets/font-svgs/ibarra-real-nova.svg";
import svg_ibm_plex_mono from "@/assets/font-svgs/ibm-plex-mono.svg";
import svg_ibm_plex_sans_arabic from "@/assets/font-svgs/ibm-plex-sans-arabic.svg";
import svg_ibm_plex_sans_condensed from "@/assets/font-svgs/ibm-plex-sans-condensed.svg";
import svg_ibm_plex_sans_devanagari from "@/assets/font-svgs/ibm-plex-sans-devanagari.svg";
import svg_ibm_plex_sans_hebrew from "@/assets/font-svgs/ibm-plex-sans-hebrew.svg";
import svg_ibm_plex_sans_jp from "@/assets/font-svgs/ibm-plex-sans-jp.svg";
import svg_ibm_plex_sans_kr from "@/assets/font-svgs/ibm-plex-sans-kr.svg";
import svg_ibm_plex_sans_thai_looped from "@/assets/font-svgs/ibm-plex-sans-thai-looped.svg";
import svg_ibm_plex_sans_thai from "@/assets/font-svgs/ibm-plex-sans-thai.svg";
import svg_ibm_plex_sans from "@/assets/font-svgs/ibm-plex-sans.svg";
import svg_ibm_plex_serif from "@/assets/font-svgs/ibm-plex-serif.svg";
import svg_iceberg from "@/assets/font-svgs/iceberg.svg";
import svg_iceland from "@/assets/font-svgs/iceland.svg";
import svg_im_fell_double_pica_sc from "@/assets/font-svgs/im-fell-double-pica-sc.svg";
import svg_im_fell_double_pica from "@/assets/font-svgs/im-fell-double-pica.svg";
import svg_im_fell_dw_pica_sc from "@/assets/font-svgs/im-fell-dw-pica-sc.svg";
import svg_im_fell_dw_pica from "@/assets/font-svgs/im-fell-dw-pica.svg";
import svg_im_fell_english_sc from "@/assets/font-svgs/im-fell-english-sc.svg";
import svg_im_fell_english from "@/assets/font-svgs/im-fell-english.svg";
import svg_im_fell_french_canon_sc from "@/assets/font-svgs/im-fell-french-canon-sc.svg";
import svg_im_fell_french_canon from "@/assets/font-svgs/im-fell-french-canon.svg";
import svg_im_fell_great_primer_sc from "@/assets/font-svgs/im-fell-great-primer-sc.svg";
import svg_im_fell_great_primer from "@/assets/font-svgs/im-fell-great-primer.svg";
import svg_imbue from "@/assets/font-svgs/imbue.svg";
import svg_imperial_script from "@/assets/font-svgs/imperial-script.svg";
import svg_imprima from "@/assets/font-svgs/imprima.svg";
import svg_inclusive_sans from "@/assets/font-svgs/inclusive-sans.svg";
import svg_inconsolata from "@/assets/font-svgs/inconsolata.svg";
import svg_inder from "@/assets/font-svgs/inder.svg";
import svg_indie_flower from "@/assets/font-svgs/indie-flower.svg";
import svg_ingrid_darling from "@/assets/font-svgs/ingrid-darling.svg";
import svg_inika from "@/assets/font-svgs/inika.svg";
import svg_inknut_antiqua from "@/assets/font-svgs/inknut-antiqua.svg";
import svg_inria_sans from "@/assets/font-svgs/inria-sans.svg";
import svg_inria_serif from "@/assets/font-svgs/inria-serif.svg";
import svg_inspiration from "@/assets/font-svgs/inspiration.svg";
import svg_instrument_sans from "@/assets/font-svgs/instrument-sans.svg";
import svg_instrument_serif from "@/assets/font-svgs/instrument-serif.svg";
import svg_inter_tight from "@/assets/font-svgs/inter-tight.svg";
import svg_inter from "@/assets/font-svgs/inter.svg";
import svg_irish_grover from "@/assets/font-svgs/irish-grover.svg";
import svg_island_moments from "@/assets/font-svgs/island-moments.svg";
import svg_istok_web from "@/assets/font-svgs/istok-web.svg";
import svg_italiana from "@/assets/font-svgs/italiana.svg";
import svg_italianno from "@/assets/font-svgs/italianno.svg";
import svg_itim from "@/assets/font-svgs/itim.svg";
import svg_jacques_francois_shadow from "@/assets/font-svgs/jacques-francois-shadow.svg";
import svg_jacques_francois from "@/assets/font-svgs/jacques-francois.svg";
import svg_jaldi from "@/assets/font-svgs/jaldi.svg";
import svg_jetbrains_mono from "@/assets/font-svgs/jetbrains-mono.svg";
import svg_jim_nightshade from "@/assets/font-svgs/jim-nightshade.svg";
import svg_joan from "@/assets/font-svgs/joan.svg";
import svg_jockey_one from "@/assets/font-svgs/jockey-one.svg";
import svg_jolly_lodger from "@/assets/font-svgs/jolly-lodger.svg";
import svg_jomhuria from "@/assets/font-svgs/jomhuria.svg";
import svg_jomolhari from "@/assets/font-svgs/jomolhari.svg";
import svg_josefin_sans from "@/assets/font-svgs/josefin-sans.svg";
import svg_josefin_slab from "@/assets/font-svgs/josefin-slab.svg";
import svg_jost from "@/assets/font-svgs/jost.svg";
import svg_joti_one from "@/assets/font-svgs/joti-one.svg";
import svg_jua from "@/assets/font-svgs/jua.svg";
import svg_judson from "@/assets/font-svgs/judson.svg";
import svg_julee from "@/assets/font-svgs/julee.svg";
import svg_julius_sans_one from "@/assets/font-svgs/julius-sans-one.svg";
import svg_junge from "@/assets/font-svgs/junge.svg";
import svg_jura from "@/assets/font-svgs/jura.svg";
import svg_just_another_hand from "@/assets/font-svgs/just-another-hand.svg";
import svg_just_me_again_down_here from "@/assets/font-svgs/just-me-again-down-here.svg";
import svg_k2d from "@/assets/font-svgs/k2d.svg";
import svg_kablammo from "@/assets/font-svgs/kablammo.svg";
import svg_kadwa from "@/assets/font-svgs/kadwa.svg";
import svg_kaisei_decol from "@/assets/font-svgs/kaisei-decol.svg";
import svg_kaisei_harunoumi from "@/assets/font-svgs/kaisei-harunoumi.svg";
import svg_kaisei_opti from "@/assets/font-svgs/kaisei-opti.svg";
import svg_kaisei_tokumin from "@/assets/font-svgs/kaisei-tokumin.svg";
import svg_kalam from "@/assets/font-svgs/kalam.svg";
import svg_kalnia from "@/assets/font-svgs/kalnia.svg";
import svg_kameron from "@/assets/font-svgs/kameron.svg";
import svg_kanit from "@/assets/font-svgs/kanit.svg";
import svg_kantumruy_pro from "@/assets/font-svgs/kantumruy-pro.svg";
import svg_karantina from "@/assets/font-svgs/karantina.svg";
import svg_karla from "@/assets/font-svgs/karla.svg";
import svg_karma from "@/assets/font-svgs/karma.svg";
import svg_katibeh from "@/assets/font-svgs/katibeh.svg";
import svg_kaushan_script from "@/assets/font-svgs/kaushan-script.svg";
import svg_kavivanar from "@/assets/font-svgs/kavivanar.svg";
import svg_kavoon from "@/assets/font-svgs/kavoon.svg";
import svg_kay_pho_du from "@/assets/font-svgs/kay-pho-du.svg";
import svg_kdam_thmor_pro from "@/assets/font-svgs/kdam-thmor-pro.svg";
import svg_keania_one from "@/assets/font-svgs/keania-one.svg";
import svg_kelly_slab from "@/assets/font-svgs/kelly-slab.svg";
import svg_kenia from "@/assets/font-svgs/kenia.svg";
import svg_khand from "@/assets/font-svgs/khand.svg";
import svg_khmer from "@/assets/font-svgs/khmer.svg";
import svg_khula from "@/assets/font-svgs/khula.svg";
import svg_kings from "@/assets/font-svgs/kings.svg";
import svg_kirang_haerang from "@/assets/font-svgs/kirang-haerang.svg";
import svg_kite_one from "@/assets/font-svgs/kite-one.svg";
import svg_kiwi_maru from "@/assets/font-svgs/kiwi-maru.svg";
import svg_klee_one from "@/assets/font-svgs/klee-one.svg";
import svg_knewave from "@/assets/font-svgs/knewave.svg";
import svg_kodchasan from "@/assets/font-svgs/kodchasan.svg";
import svg_koh_santepheap from "@/assets/font-svgs/koh-santepheap.svg";
import svg_koho from "@/assets/font-svgs/koho.svg";
import svg_kolker_brush from "@/assets/font-svgs/kolker-brush.svg";
import svg_konkhmer_sleokchher from "@/assets/font-svgs/konkhmer-sleokchher.svg";
import svg_kosugi_maru from "@/assets/font-svgs/kosugi-maru.svg";
import svg_kosugi from "@/assets/font-svgs/kosugi.svg";
import svg_kotta_one from "@/assets/font-svgs/kotta-one.svg";
import svg_koulen from "@/assets/font-svgs/koulen.svg";
import svg_kranky from "@/assets/font-svgs/kranky.svg";
import svg_kreon from "@/assets/font-svgs/kreon.svg";
import svg_kristi from "@/assets/font-svgs/kristi.svg";
import svg_krona_one from "@/assets/font-svgs/krona-one.svg";
import svg_krub from "@/assets/font-svgs/krub.svg";
import svg_kufam from "@/assets/font-svgs/kufam.svg";
import svg_kulim_park from "@/assets/font-svgs/kulim-park.svg";
import svg_kumar_one_outline from "@/assets/font-svgs/kumar-one-outline.svg";
import svg_kumar_one from "@/assets/font-svgs/kumar-one.svg";
import svg_kumbh_sans from "@/assets/font-svgs/kumbh-sans.svg";
import svg_kurale from "@/assets/font-svgs/kurale.svg";
import svg_la_belle_aurore from "@/assets/font-svgs/la-belle-aurore.svg";
import svg_labrada from "@/assets/font-svgs/labrada.svg";
import svg_lacquer from "@/assets/font-svgs/lacquer.svg";
import svg_laila from "@/assets/font-svgs/laila.svg";
import svg_lakki_reddy from "@/assets/font-svgs/lakki-reddy.svg";
import svg_lalezar from "@/assets/font-svgs/lalezar.svg";
import svg_lancelot from "@/assets/font-svgs/lancelot.svg";
import svg_langar from "@/assets/font-svgs/langar.svg";
import svg_lateef from "@/assets/font-svgs/lateef.svg";
import svg_lato from "@/assets/font-svgs/lato.svg";
import svg_lavishly_yours from "@/assets/font-svgs/lavishly-yours.svg";
import svg_league_gothic from "@/assets/font-svgs/league-gothic.svg";
import svg_league_script from "@/assets/font-svgs/league-script.svg";
import svg_league_spartan from "@/assets/font-svgs/league-spartan.svg";
import svg_leckerli_one from "@/assets/font-svgs/leckerli-one.svg";
import svg_ledger from "@/assets/font-svgs/ledger.svg";
import svg_lekton from "@/assets/font-svgs/lekton.svg";
import svg_lemon from "@/assets/font-svgs/lemon.svg";
import svg_lemonada from "@/assets/font-svgs/lemonada.svg";
import svg_lexend_deca from "@/assets/font-svgs/lexend-deca.svg";
import svg_lexend_exa from "@/assets/font-svgs/lexend-exa.svg";
import svg_lexend_giga from "@/assets/font-svgs/lexend-giga.svg";
import svg_lexend_mega from "@/assets/font-svgs/lexend-mega.svg";
import svg_lexend_peta from "@/assets/font-svgs/lexend-peta.svg";
import svg_lexend_tera from "@/assets/font-svgs/lexend-tera.svg";
import svg_lexend_zetta from "@/assets/font-svgs/lexend-zetta.svg";
import svg_lexend from "@/assets/font-svgs/lexend.svg";
import svg_libre_barcode_128_text from "@/assets/font-svgs/libre-barcode-128-text.svg";
import svg_libre_barcode_128 from "@/assets/font-svgs/libre-barcode-128.svg";
import svg_libre_barcode_39_extended_text from "@/assets/font-svgs/libre-barcode-39-extended-text.svg";
import svg_libre_barcode_39_extended from "@/assets/font-svgs/libre-barcode-39-extended.svg";
import svg_libre_barcode_39_text from "@/assets/font-svgs/libre-barcode-39-text.svg";
import svg_libre_barcode_39 from "@/assets/font-svgs/libre-barcode-39.svg";
import svg_libre_barcode_ean13_text from "@/assets/font-svgs/libre-barcode-ean13-text.svg";
import svg_libre_baskerville from "@/assets/font-svgs/libre-baskerville.svg";
import svg_libre_bodoni from "@/assets/font-svgs/libre-bodoni.svg";
import svg_libre_caslon_display from "@/assets/font-svgs/libre-caslon-display.svg";
import svg_libre_caslon_text from "@/assets/font-svgs/libre-caslon-text.svg";
import svg_libre_franklin from "@/assets/font-svgs/libre-franklin.svg";
import svg_licorice from "@/assets/font-svgs/licorice.svg";
import svg_life_savers from "@/assets/font-svgs/life-savers.svg";
import svg_lilita_one from "@/assets/font-svgs/lilita-one.svg";
import svg_lily_script_one from "@/assets/font-svgs/lily-script-one.svg";
import svg_limelight from "@/assets/font-svgs/limelight.svg";
import svg_linden_hill from "@/assets/font-svgs/linden-hill.svg";
import svg_linefont from "@/assets/font-svgs/linefont.svg";
import svg_lisu_bosa from "@/assets/font-svgs/lisu-bosa.svg";
import svg_literata from "@/assets/font-svgs/literata.svg";
import svg_liu_jian_mao_cao from "@/assets/font-svgs/liu-jian-mao-cao.svg";
import svg_livvic from "@/assets/font-svgs/livvic.svg";
import svg_lobster_two from "@/assets/font-svgs/lobster-two.svg";
import svg_lobster from "@/assets/font-svgs/lobster.svg";
import svg_londrina_outline from "@/assets/font-svgs/londrina-outline.svg";
import svg_londrina_shadow from "@/assets/font-svgs/londrina-shadow.svg";
import svg_londrina_sketch from "@/assets/font-svgs/londrina-sketch.svg";
import svg_londrina_solid from "@/assets/font-svgs/londrina-solid.svg";
import svg_long_cang from "@/assets/font-svgs/long-cang.svg";
import svg_lora from "@/assets/font-svgs/lora.svg";
import svg_love_light from "@/assets/font-svgs/love-light.svg";
import svg_love_ya_like_a_sister from "@/assets/font-svgs/love-ya-like-a-sister.svg";
import svg_loved_by_the_king from "@/assets/font-svgs/loved-by-the-king.svg";
import svg_lovers_quarrel from "@/assets/font-svgs/lovers-quarrel.svg";
import svg_luckiest_guy from "@/assets/font-svgs/luckiest-guy.svg";
import svg_lugrasimo from "@/assets/font-svgs/lugrasimo.svg";
import svg_lumanosimo from "@/assets/font-svgs/lumanosimo.svg";
import svg_lunasima from "@/assets/font-svgs/lunasima.svg";
import svg_lusitana from "@/assets/font-svgs/lusitana.svg";
import svg_lustria from "@/assets/font-svgs/lustria.svg";
import svg_luxurious_roman from "@/assets/font-svgs/luxurious-roman.svg";
import svg_luxurious_script from "@/assets/font-svgs/luxurious-script.svg";
import svg_m_plus_1_code from "@/assets/font-svgs/m-plus-1-code.svg";
import svg_m_plus_1 from "@/assets/font-svgs/m-plus-1.svg";
import svg_m_plus_1p from "@/assets/font-svgs/m-plus-1p.svg";
import svg_m_plus_2 from "@/assets/font-svgs/m-plus-2.svg";
import svg_m_plus_code_latin from "@/assets/font-svgs/m-plus-code-latin.svg";
import svg_m_plus_rounded_1c from "@/assets/font-svgs/m-plus-rounded-1c.svg";
import svg_ma_shan_zheng from "@/assets/font-svgs/ma-shan-zheng.svg";
import svg_macondo_swash_caps from "@/assets/font-svgs/macondo-swash-caps.svg";
import svg_macondo from "@/assets/font-svgs/macondo.svg";
import svg_mada from "@/assets/font-svgs/mada.svg";
import svg_magra from "@/assets/font-svgs/magra.svg";
import svg_maiden_orange from "@/assets/font-svgs/maiden-orange.svg";
import svg_maitree from "@/assets/font-svgs/maitree.svg";
import svg_major_mono_display from "@/assets/font-svgs/major-mono-display.svg";
import svg_mako from "@/assets/font-svgs/mako.svg";
import svg_mali from "@/assets/font-svgs/mali.svg";
import svg_mallanna from "@/assets/font-svgs/mallanna.svg";
import svg_mandali from "@/assets/font-svgs/mandali.svg";
import svg_manjari from "@/assets/font-svgs/manjari.svg";
import svg_manrope from "@/assets/font-svgs/manrope.svg";
import svg_mansalva from "@/assets/font-svgs/mansalva.svg";
import svg_manuale from "@/assets/font-svgs/manuale.svg";
import svg_marcellus_sc from "@/assets/font-svgs/marcellus-sc.svg";
import svg_marcellus from "@/assets/font-svgs/marcellus.svg";
import svg_marck_script from "@/assets/font-svgs/marck-script.svg";
import svg_margarine from "@/assets/font-svgs/margarine.svg";
import svg_marhey from "@/assets/font-svgs/marhey.svg";
import svg_markazi_text from "@/assets/font-svgs/markazi-text.svg";
import svg_marko_one from "@/assets/font-svgs/marko-one.svg";
import svg_marmelad from "@/assets/font-svgs/marmelad.svg";
import svg_martel_sans from "@/assets/font-svgs/martel-sans.svg";
import svg_martel from "@/assets/font-svgs/martel.svg";
import svg_martian_mono from "@/assets/font-svgs/martian-mono.svg";
import svg_marvel from "@/assets/font-svgs/marvel.svg";
import svg_mate_sc from "@/assets/font-svgs/mate-sc.svg";
import svg_mate from "@/assets/font-svgs/mate.svg";
import svg_material_icons_outlined from "@/assets/font-svgs/material-icons-outlined.svg";
import svg_material_icons_round from "@/assets/font-svgs/material-icons-round.svg";
import svg_material_icons_sharp from "@/assets/font-svgs/material-icons-sharp.svg";
import svg_material_icons_two_tone from "@/assets/font-svgs/material-icons-two-tone.svg";
import svg_material_icons from "@/assets/font-svgs/material-icons.svg";
import svg_material_symbols_outlined from "@/assets/font-svgs/material-symbols-outlined.svg";
import svg_material_symbols_rounded from "@/assets/font-svgs/material-symbols-rounded.svg";
import svg_material_symbols_sharp from "@/assets/font-svgs/material-symbols-sharp.svg";
import svg_maven_pro from "@/assets/font-svgs/maven-pro.svg";
import svg_mclaren from "@/assets/font-svgs/mclaren.svg";
import svg_mea_culpa from "@/assets/font-svgs/mea-culpa.svg";
import svg_meddon from "@/assets/font-svgs/meddon.svg";
import svg_medievalsharp from "@/assets/font-svgs/medievalsharp.svg";
import svg_medula_one from "@/assets/font-svgs/medula-one.svg";
import svg_meera_inimai from "@/assets/font-svgs/meera-inimai.svg";
import svg_megrim from "@/assets/font-svgs/megrim.svg";
import svg_meie_script from "@/assets/font-svgs/meie-script.svg";
import svg_meow_script from "@/assets/font-svgs/meow-script.svg";
import svg_merienda from "@/assets/font-svgs/merienda.svg";
import svg_merriweather_sans from "@/assets/font-svgs/merriweather-sans.svg";
import svg_merriweather from "@/assets/font-svgs/merriweather.svg";
import svg_metal_mania from "@/assets/font-svgs/metal-mania.svg";
import svg_metal from "@/assets/font-svgs/metal.svg";
import svg_metamorphous from "@/assets/font-svgs/metamorphous.svg";
import svg_metrophobic from "@/assets/font-svgs/metrophobic.svg";
import svg_michroma from "@/assets/font-svgs/michroma.svg";
import svg_milonga from "@/assets/font-svgs/milonga.svg";
import svg_miltonian_tattoo from "@/assets/font-svgs/miltonian-tattoo.svg";
import svg_miltonian from "@/assets/font-svgs/miltonian.svg";
import svg_mina from "@/assets/font-svgs/mina.svg";
import svg_mingzat from "@/assets/font-svgs/mingzat.svg";
import svg_miniver from "@/assets/font-svgs/miniver.svg";
import svg_miriam_libre from "@/assets/font-svgs/miriam-libre.svg";
import svg_mirza from "@/assets/font-svgs/mirza.svg";
import svg_miss_fajardose from "@/assets/font-svgs/miss-fajardose.svg";
import svg_mitr from "@/assets/font-svgs/mitr.svg";
import svg_mochiy_pop_one from "@/assets/font-svgs/mochiy-pop-one.svg";
import svg_mochiy_pop_p_one from "@/assets/font-svgs/mochiy-pop-p-one.svg";
import svg_modak from "@/assets/font-svgs/modak.svg";
import svg_modern_antiqua from "@/assets/font-svgs/modern-antiqua.svg";
import svg_mogra from "@/assets/font-svgs/mogra.svg";
import svg_mohave from "@/assets/font-svgs/mohave.svg";
import svg_moirai_one from "@/assets/font-svgs/moirai-one.svg";
import svg_molengo from "@/assets/font-svgs/molengo.svg";
import svg_monda from "@/assets/font-svgs/monda.svg";
import svg_monofett from "@/assets/font-svgs/monofett.svg";
import svg_monomaniac_one from "@/assets/font-svgs/monomaniac-one.svg";
import svg_monoton from "@/assets/font-svgs/monoton.svg";
import svg_monsieur_la_doulaise from "@/assets/font-svgs/monsieur-la-doulaise.svg";
import svg_montaga from "@/assets/font-svgs/montaga.svg";
import svg_montagu_slab from "@/assets/font-svgs/montagu-slab.svg";
import svg_montecarlo from "@/assets/font-svgs/montecarlo.svg";
import svg_montez from "@/assets/font-svgs/montez.svg";
import svg_montserrat_alternates from "@/assets/font-svgs/montserrat-alternates.svg";
import svg_montserrat_subrayada from "@/assets/font-svgs/montserrat-subrayada.svg";
import svg_montserrat from "@/assets/font-svgs/montserrat.svg";
import svg_moo_lah_lah from "@/assets/font-svgs/moo-lah-lah.svg";
import svg_mooli from "@/assets/font-svgs/mooli.svg";
import svg_moon_dance from "@/assets/font-svgs/moon-dance.svg";
import svg_moul from "@/assets/font-svgs/moul.svg";
import svg_moulpali from "@/assets/font-svgs/moulpali.svg";
import svg_mountains_of_christmas from "@/assets/font-svgs/mountains-of-christmas.svg";
import svg_mouse_memoirs from "@/assets/font-svgs/mouse-memoirs.svg";
import svg_mr_bedfort from "@/assets/font-svgs/mr-bedfort.svg";
import svg_mr_dafoe from "@/assets/font-svgs/mr-dafoe.svg";
import svg_mr_de_haviland from "@/assets/font-svgs/mr-de-haviland.svg";
import svg_mrs_saint_delafield from "@/assets/font-svgs/mrs-saint-delafield.svg";
import svg_mrs_sheppards from "@/assets/font-svgs/mrs-sheppards.svg";
import svg_ms_madi from "@/assets/font-svgs/ms-madi.svg";
import svg_mukta_mahee from "@/assets/font-svgs/mukta-mahee.svg";
import svg_mukta_malar from "@/assets/font-svgs/mukta-malar.svg";
import svg_mukta_vaani from "@/assets/font-svgs/mukta-vaani.svg";
import svg_mukta from "@/assets/font-svgs/mukta.svg";
import svg_mulish from "@/assets/font-svgs/mulish.svg";
import svg_murecho from "@/assets/font-svgs/murecho.svg";
import svg_museomoderno from "@/assets/font-svgs/museomoderno.svg";
import svg_my_soul from "@/assets/font-svgs/my-soul.svg";
import svg_mynerve from "@/assets/font-svgs/mynerve.svg";
import svg_mystery_quest from "@/assets/font-svgs/mystery-quest.svg";
import svg_nabla from "@/assets/font-svgs/nabla.svg";
import svg_nanum_brush_script from "@/assets/font-svgs/nanum-brush-script.svg";
import svg_nanum_gothic_coding from "@/assets/font-svgs/nanum-gothic-coding.svg";
import svg_nanum_gothic from "@/assets/font-svgs/nanum-gothic.svg";
import svg_nanum_myeongjo from "@/assets/font-svgs/nanum-myeongjo.svg";
import svg_nanum_pen_script from "@/assets/font-svgs/nanum-pen-script.svg";
import svg_narnoor from "@/assets/font-svgs/narnoor.svg";
import svg_neonderthaw from "@/assets/font-svgs/neonderthaw.svg";
import svg_nerko_one from "@/assets/font-svgs/nerko-one.svg";
import svg_neucha from "@/assets/font-svgs/neucha.svg";
import svg_neuton from "@/assets/font-svgs/neuton.svg";
import svg_new_rocker from "@/assets/font-svgs/new-rocker.svg";
import svg_new_tegomin from "@/assets/font-svgs/new-tegomin.svg";
import svg_news_cycle from "@/assets/font-svgs/news-cycle.svg";
import svg_newsreader from "@/assets/font-svgs/newsreader.svg";
import svg_niconne from "@/assets/font-svgs/niconne.svg";
import svg_niramit from "@/assets/font-svgs/niramit.svg";
import svg_nixie_one from "@/assets/font-svgs/nixie-one.svg";
import svg_nobile from "@/assets/font-svgs/nobile.svg";
import svg_nokora from "@/assets/font-svgs/nokora.svg";
import svg_norican from "@/assets/font-svgs/norican.svg";
import svg_nosifer from "@/assets/font-svgs/nosifer.svg";
import svg_notable from "@/assets/font-svgs/notable.svg";
import svg_nothing_you_could_do from "@/assets/font-svgs/nothing-you-could-do.svg";
import svg_noticia_text from "@/assets/font-svgs/noticia-text.svg";
import svg_noto_color_emoji from "@/assets/font-svgs/noto-color-emoji.svg";
import svg_noto_emoji from "@/assets/font-svgs/noto-emoji.svg";
import svg_noto_kufi_arabic from "@/assets/font-svgs/noto-kufi-arabic.svg";
import svg_noto_music from "@/assets/font-svgs/noto-music.svg";
import svg_noto_naskh_arabic from "@/assets/font-svgs/noto-naskh-arabic.svg";
import svg_noto_nastaliq_urdu from "@/assets/font-svgs/noto-nastaliq-urdu.svg";
import svg_noto_rashi_hebrew from "@/assets/font-svgs/noto-rashi-hebrew.svg";
import svg_noto_sans_adlam_unjoined from "@/assets/font-svgs/noto-sans-adlam-unjoined.svg";
import svg_noto_sans_adlam from "@/assets/font-svgs/noto-sans-adlam.svg";
import svg_noto_sans_anatolian_hieroglyphs from "@/assets/font-svgs/noto-sans-anatolian-hieroglyphs.svg";
import svg_noto_sans_arabic from "@/assets/font-svgs/noto-sans-arabic.svg";
import svg_noto_sans_armenian from "@/assets/font-svgs/noto-sans-armenian.svg";
import svg_noto_sans_avestan from "@/assets/font-svgs/noto-sans-avestan.svg";
import svg_noto_sans_balinese from "@/assets/font-svgs/noto-sans-balinese.svg";
import svg_noto_sans_bamum from "@/assets/font-svgs/noto-sans-bamum.svg";
import svg_noto_sans_bassa_vah from "@/assets/font-svgs/noto-sans-bassa-vah.svg";
import svg_noto_sans_batak from "@/assets/font-svgs/noto-sans-batak.svg";
import svg_noto_sans_bengali from "@/assets/font-svgs/noto-sans-bengali.svg";
import svg_noto_sans_bhaiksuki from "@/assets/font-svgs/noto-sans-bhaiksuki.svg";
import svg_noto_sans_brahmi from "@/assets/font-svgs/noto-sans-brahmi.svg";
import svg_noto_sans_buginese from "@/assets/font-svgs/noto-sans-buginese.svg";
import svg_noto_sans_buhid from "@/assets/font-svgs/noto-sans-buhid.svg";
import svg_noto_sans_canadian_aboriginal from "@/assets/font-svgs/noto-sans-canadian-aboriginal.svg";
import svg_noto_sans_carian from "@/assets/font-svgs/noto-sans-carian.svg";
import svg_noto_sans_caucasian_albanian from "@/assets/font-svgs/noto-sans-caucasian-albanian.svg";
import svg_noto_sans_chakma from "@/assets/font-svgs/noto-sans-chakma.svg";
import svg_noto_sans_cham from "@/assets/font-svgs/noto-sans-cham.svg";
import svg_noto_sans_cherokee from "@/assets/font-svgs/noto-sans-cherokee.svg";
import svg_noto_sans_chorasmian from "@/assets/font-svgs/noto-sans-chorasmian.svg";
import svg_noto_sans_coptic from "@/assets/font-svgs/noto-sans-coptic.svg";
import svg_noto_sans_cuneiform from "@/assets/font-svgs/noto-sans-cuneiform.svg";
import svg_noto_sans_cypriot from "@/assets/font-svgs/noto-sans-cypriot.svg";
import svg_noto_sans_cypro_minoan from "@/assets/font-svgs/noto-sans-cypro-minoan.svg";
import svg_noto_sans_deseret from "@/assets/font-svgs/noto-sans-deseret.svg";
import svg_noto_sans_devanagari from "@/assets/font-svgs/noto-sans-devanagari.svg";
import svg_noto_sans_display from "@/assets/font-svgs/noto-sans-display.svg";
import svg_noto_sans_duployan from "@/assets/font-svgs/noto-sans-duployan.svg";
import svg_noto_sans_egyptian_hieroglyphs from "@/assets/font-svgs/noto-sans-egyptian-hieroglyphs.svg";
import svg_noto_sans_elbasan from "@/assets/font-svgs/noto-sans-elbasan.svg";
import svg_noto_sans_elymaic from "@/assets/font-svgs/noto-sans-elymaic.svg";
import svg_noto_sans_ethiopic from "@/assets/font-svgs/noto-sans-ethiopic.svg";
import svg_noto_sans_georgian from "@/assets/font-svgs/noto-sans-georgian.svg";
import svg_noto_sans_glagolitic from "@/assets/font-svgs/noto-sans-glagolitic.svg";
import svg_noto_sans_gothic from "@/assets/font-svgs/noto-sans-gothic.svg";
import svg_noto_sans_grantha from "@/assets/font-svgs/noto-sans-grantha.svg";
import svg_noto_sans_gujarati from "@/assets/font-svgs/noto-sans-gujarati.svg";
import svg_noto_sans_gunjala_gondi from "@/assets/font-svgs/noto-sans-gunjala-gondi.svg";
import svg_noto_sans_gurmukhi from "@/assets/font-svgs/noto-sans-gurmukhi.svg";
import svg_noto_sans_hanifi_rohingya from "@/assets/font-svgs/noto-sans-hanifi-rohingya.svg";
import svg_noto_sans_hanunoo from "@/assets/font-svgs/noto-sans-hanunoo.svg";
import svg_noto_sans_hatran from "@/assets/font-svgs/noto-sans-hatran.svg";
import svg_noto_sans_hebrew from "@/assets/font-svgs/noto-sans-hebrew.svg";
import svg_noto_sans_hk from "@/assets/font-svgs/noto-sans-hk.svg";
import svg_noto_sans_imperial_aramaic from "@/assets/font-svgs/noto-sans-imperial-aramaic.svg";
import svg_noto_sans_indic_siyaq_numbers from "@/assets/font-svgs/noto-sans-indic-siyaq-numbers.svg";
import svg_noto_sans_inscriptional_pahlavi from "@/assets/font-svgs/noto-sans-inscriptional-pahlavi.svg";
import svg_noto_sans_inscriptional_parthian from "@/assets/font-svgs/noto-sans-inscriptional-parthian.svg";
import svg_noto_sans_javanese from "@/assets/font-svgs/noto-sans-javanese.svg";
import svg_noto_sans_jp from "@/assets/font-svgs/noto-sans-jp.svg";
import svg_noto_sans_kaithi from "@/assets/font-svgs/noto-sans-kaithi.svg";
import svg_noto_sans_kannada from "@/assets/font-svgs/noto-sans-kannada.svg";
import svg_noto_sans_kawi from "@/assets/font-svgs/noto-sans-kawi.svg";
import svg_noto_sans_kayah_li from "@/assets/font-svgs/noto-sans-kayah-li.svg";
import svg_noto_sans_kharoshthi from "@/assets/font-svgs/noto-sans-kharoshthi.svg";
import svg_noto_sans_khmer from "@/assets/font-svgs/noto-sans-khmer.svg";
import svg_noto_sans_khojki from "@/assets/font-svgs/noto-sans-khojki.svg";
import svg_noto_sans_khudawadi from "@/assets/font-svgs/noto-sans-khudawadi.svg";
import svg_noto_sans_kr from "@/assets/font-svgs/noto-sans-kr.svg";
import svg_noto_sans_lao_looped from "@/assets/font-svgs/noto-sans-lao-looped.svg";
import svg_noto_sans_lao from "@/assets/font-svgs/noto-sans-lao.svg";
import svg_noto_sans_lepcha from "@/assets/font-svgs/noto-sans-lepcha.svg";
import svg_noto_sans_limbu from "@/assets/font-svgs/noto-sans-limbu.svg";
import svg_noto_sans_linear_a from "@/assets/font-svgs/noto-sans-linear-a.svg";
import svg_noto_sans_linear_b from "@/assets/font-svgs/noto-sans-linear-b.svg";
import svg_noto_sans_lisu from "@/assets/font-svgs/noto-sans-lisu.svg";
import svg_noto_sans_lycian from "@/assets/font-svgs/noto-sans-lycian.svg";
import svg_noto_sans_lydian from "@/assets/font-svgs/noto-sans-lydian.svg";
import svg_noto_sans_mahajani from "@/assets/font-svgs/noto-sans-mahajani.svg";
import svg_noto_sans_malayalam from "@/assets/font-svgs/noto-sans-malayalam.svg";
import svg_noto_sans_mandaic from "@/assets/font-svgs/noto-sans-mandaic.svg";
import svg_noto_sans_manichaean from "@/assets/font-svgs/noto-sans-manichaean.svg";
import svg_noto_sans_marchen from "@/assets/font-svgs/noto-sans-marchen.svg";
import svg_noto_sans_masaram_gondi from "@/assets/font-svgs/noto-sans-masaram-gondi.svg";
import svg_noto_sans_math from "@/assets/font-svgs/noto-sans-math.svg";
import svg_noto_sans_mayan_numerals from "@/assets/font-svgs/noto-sans-mayan-numerals.svg";
import svg_noto_sans_medefaidrin from "@/assets/font-svgs/noto-sans-medefaidrin.svg";
import svg_noto_sans_meetei_mayek from "@/assets/font-svgs/noto-sans-meetei-mayek.svg";
import svg_noto_sans_mende_kikakui from "@/assets/font-svgs/noto-sans-mende-kikakui.svg";
import svg_noto_sans_meroitic from "@/assets/font-svgs/noto-sans-meroitic.svg";
import svg_noto_sans_miao from "@/assets/font-svgs/noto-sans-miao.svg";
import svg_noto_sans_modi from "@/assets/font-svgs/noto-sans-modi.svg";
import svg_noto_sans_mongolian from "@/assets/font-svgs/noto-sans-mongolian.svg";
import svg_noto_sans_mono from "@/assets/font-svgs/noto-sans-mono.svg";
import svg_noto_sans_mro from "@/assets/font-svgs/noto-sans-mro.svg";
import svg_noto_sans_multani from "@/assets/font-svgs/noto-sans-multani.svg";
import svg_noto_sans_myanmar from "@/assets/font-svgs/noto-sans-myanmar.svg";
import svg_noto_sans_nabataean from "@/assets/font-svgs/noto-sans-nabataean.svg";
import svg_noto_sans_nag_mundari from "@/assets/font-svgs/noto-sans-nag-mundari.svg";
import svg_noto_sans_nandinagari from "@/assets/font-svgs/noto-sans-nandinagari.svg";
import svg_noto_sans_new_tai_lue from "@/assets/font-svgs/noto-sans-new-tai-lue.svg";
import svg_noto_sans_newa from "@/assets/font-svgs/noto-sans-newa.svg";
import svg_noto_sans_nko_unjoined from "@/assets/font-svgs/noto-sans-nko-unjoined.svg";
import svg_noto_sans_nko from "@/assets/font-svgs/noto-sans-nko.svg";
import svg_noto_sans_nushu from "@/assets/font-svgs/noto-sans-nushu.svg";
import svg_noto_sans_ogham from "@/assets/font-svgs/noto-sans-ogham.svg";
import svg_noto_sans_ol_chiki from "@/assets/font-svgs/noto-sans-ol-chiki.svg";
import svg_noto_sans_old_hungarian from "@/assets/font-svgs/noto-sans-old-hungarian.svg";
import svg_noto_sans_old_italic from "@/assets/font-svgs/noto-sans-old-italic.svg";
import svg_noto_sans_old_north_arabian from "@/assets/font-svgs/noto-sans-old-north-arabian.svg";
import svg_noto_sans_old_permic from "@/assets/font-svgs/noto-sans-old-permic.svg";
import svg_noto_sans_old_persian from "@/assets/font-svgs/noto-sans-old-persian.svg";
import svg_noto_sans_old_sogdian from "@/assets/font-svgs/noto-sans-old-sogdian.svg";
import svg_noto_sans_old_south_arabian from "@/assets/font-svgs/noto-sans-old-south-arabian.svg";
import svg_noto_sans_old_turkic from "@/assets/font-svgs/noto-sans-old-turkic.svg";
import svg_noto_sans_oriya from "@/assets/font-svgs/noto-sans-oriya.svg";
import svg_noto_sans_osage from "@/assets/font-svgs/noto-sans-osage.svg";
import svg_noto_sans_osmanya from "@/assets/font-svgs/noto-sans-osmanya.svg";
import svg_noto_sans_pahawh_hmong from "@/assets/font-svgs/noto-sans-pahawh-hmong.svg";
import svg_noto_sans_palmyrene from "@/assets/font-svgs/noto-sans-palmyrene.svg";
import svg_noto_sans_pau_cin_hau from "@/assets/font-svgs/noto-sans-pau-cin-hau.svg";
import svg_noto_sans_phags_pa from "@/assets/font-svgs/noto-sans-phags-pa.svg";
import svg_noto_sans_phoenician from "@/assets/font-svgs/noto-sans-phoenician.svg";
import svg_noto_sans_psalter_pahlavi from "@/assets/font-svgs/noto-sans-psalter-pahlavi.svg";
import svg_noto_sans_rejang from "@/assets/font-svgs/noto-sans-rejang.svg";
import svg_noto_sans_runic from "@/assets/font-svgs/noto-sans-runic.svg";
import svg_noto_sans_samaritan from "@/assets/font-svgs/noto-sans-samaritan.svg";
import svg_noto_sans_saurashtra from "@/assets/font-svgs/noto-sans-saurashtra.svg";
import svg_noto_sans_sc from "@/assets/font-svgs/noto-sans-sc.svg";
import svg_noto_sans_sharada from "@/assets/font-svgs/noto-sans-sharada.svg";
import svg_noto_sans_shavian from "@/assets/font-svgs/noto-sans-shavian.svg";
import svg_noto_sans_siddham from "@/assets/font-svgs/noto-sans-siddham.svg";
import svg_noto_sans_signwriting from "@/assets/font-svgs/noto-sans-signwriting.svg";
import svg_noto_sans_sinhala from "@/assets/font-svgs/noto-sans-sinhala.svg";
import svg_noto_sans_sogdian from "@/assets/font-svgs/noto-sans-sogdian.svg";
import svg_noto_sans_sora_sompeng from "@/assets/font-svgs/noto-sans-sora-sompeng.svg";
import svg_noto_sans_soyombo from "@/assets/font-svgs/noto-sans-soyombo.svg";
import svg_noto_sans_sundanese from "@/assets/font-svgs/noto-sans-sundanese.svg";
import svg_noto_sans_syloti_nagri from "@/assets/font-svgs/noto-sans-syloti-nagri.svg";
import svg_noto_sans_symbols_2 from "@/assets/font-svgs/noto-sans-symbols-2.svg";
import svg_noto_sans_symbols from "@/assets/font-svgs/noto-sans-symbols.svg";
import svg_noto_sans_syriac_eastern from "@/assets/font-svgs/noto-sans-syriac-eastern.svg";
import svg_noto_sans_syriac from "@/assets/font-svgs/noto-sans-syriac.svg";
import svg_noto_sans_tagalog from "@/assets/font-svgs/noto-sans-tagalog.svg";
import svg_noto_sans_tagbanwa from "@/assets/font-svgs/noto-sans-tagbanwa.svg";
import svg_noto_sans_tai_le from "@/assets/font-svgs/noto-sans-tai-le.svg";
import svg_noto_sans_tai_tham from "@/assets/font-svgs/noto-sans-tai-tham.svg";
import svg_noto_sans_tai_viet from "@/assets/font-svgs/noto-sans-tai-viet.svg";
import svg_noto_sans_takri from "@/assets/font-svgs/noto-sans-takri.svg";
import svg_noto_sans_tamil_supplement from "@/assets/font-svgs/noto-sans-tamil-supplement.svg";
import svg_noto_sans_tamil from "@/assets/font-svgs/noto-sans-tamil.svg";
import svg_noto_sans_tangsa from "@/assets/font-svgs/noto-sans-tangsa.svg";
import svg_noto_sans_tc from "@/assets/font-svgs/noto-sans-tc.svg";
import svg_noto_sans_telugu from "@/assets/font-svgs/noto-sans-telugu.svg";
import svg_noto_sans_thaana from "@/assets/font-svgs/noto-sans-thaana.svg";
import svg_noto_sans_thai_looped from "@/assets/font-svgs/noto-sans-thai-looped.svg";
import svg_noto_sans_thai from "@/assets/font-svgs/noto-sans-thai.svg";
import svg_noto_sans_tifinagh from "@/assets/font-svgs/noto-sans-tifinagh.svg";
import svg_noto_sans_tirhuta from "@/assets/font-svgs/noto-sans-tirhuta.svg";
import svg_noto_sans_ugaritic from "@/assets/font-svgs/noto-sans-ugaritic.svg";
import svg_noto_sans_vai from "@/assets/font-svgs/noto-sans-vai.svg";
import svg_noto_sans_vithkuqi from "@/assets/font-svgs/noto-sans-vithkuqi.svg";
import svg_noto_sans_wancho from "@/assets/font-svgs/noto-sans-wancho.svg";
import svg_noto_sans_warang_citi from "@/assets/font-svgs/noto-sans-warang-citi.svg";
import svg_noto_sans_yi from "@/assets/font-svgs/noto-sans-yi.svg";
import svg_noto_sans_zanabazar_square from "@/assets/font-svgs/noto-sans-zanabazar-square.svg";
import svg_noto_sans from "@/assets/font-svgs/noto-sans.svg";
import svg_noto_serif_ahom from "@/assets/font-svgs/noto-serif-ahom.svg";
import svg_noto_serif_armenian from "@/assets/font-svgs/noto-serif-armenian.svg";
import svg_noto_serif_balinese from "@/assets/font-svgs/noto-serif-balinese.svg";
import svg_noto_serif_bengali from "@/assets/font-svgs/noto-serif-bengali.svg";
import svg_noto_serif_devanagari from "@/assets/font-svgs/noto-serif-devanagari.svg";
import svg_noto_serif_display from "@/assets/font-svgs/noto-serif-display.svg";
import svg_noto_serif_dogra from "@/assets/font-svgs/noto-serif-dogra.svg";
import svg_noto_serif_ethiopic from "@/assets/font-svgs/noto-serif-ethiopic.svg";
import svg_noto_serif_georgian from "@/assets/font-svgs/noto-serif-georgian.svg";
import svg_noto_serif_grantha from "@/assets/font-svgs/noto-serif-grantha.svg";
import svg_noto_serif_gujarati from "@/assets/font-svgs/noto-serif-gujarati.svg";
import svg_noto_serif_gurmukhi from "@/assets/font-svgs/noto-serif-gurmukhi.svg";
import svg_noto_serif_hebrew from "@/assets/font-svgs/noto-serif-hebrew.svg";
import svg_noto_serif_hk from "@/assets/font-svgs/noto-serif-hk.svg";
import svg_noto_serif_jp from "@/assets/font-svgs/noto-serif-jp.svg";
import svg_noto_serif_kannada from "@/assets/font-svgs/noto-serif-kannada.svg";
import svg_noto_serif_khitan_small_script from "@/assets/font-svgs/noto-serif-khitan-small-script.svg";
import svg_noto_serif_khmer from "@/assets/font-svgs/noto-serif-khmer.svg";
import svg_noto_serif_khojki from "@/assets/font-svgs/noto-serif-khojki.svg";
import svg_noto_serif_kr from "@/assets/font-svgs/noto-serif-kr.svg";
import svg_noto_serif_lao from "@/assets/font-svgs/noto-serif-lao.svg";
import svg_noto_serif_makasar from "@/assets/font-svgs/noto-serif-makasar.svg";
import svg_noto_serif_malayalam from "@/assets/font-svgs/noto-serif-malayalam.svg";
import svg_noto_serif_myanmar from "@/assets/font-svgs/noto-serif-myanmar.svg";
import svg_noto_serif_np_hmong from "@/assets/font-svgs/noto-serif-np-hmong.svg";
import svg_noto_serif_old_uyghur from "@/assets/font-svgs/noto-serif-old-uyghur.svg";
import svg_noto_serif_oriya from "@/assets/font-svgs/noto-serif-oriya.svg";
import svg_noto_serif_ottoman_siyaq from "@/assets/font-svgs/noto-serif-ottoman-siyaq.svg";
import svg_noto_serif_sc from "@/assets/font-svgs/noto-serif-sc.svg";
import svg_noto_serif_sinhala from "@/assets/font-svgs/noto-serif-sinhala.svg";
import svg_noto_serif_tamil from "@/assets/font-svgs/noto-serif-tamil.svg";
import svg_noto_serif_tangut from "@/assets/font-svgs/noto-serif-tangut.svg";
import svg_noto_serif_tc from "@/assets/font-svgs/noto-serif-tc.svg";
import svg_noto_serif_telugu from "@/assets/font-svgs/noto-serif-telugu.svg";
import svg_noto_serif_thai from "@/assets/font-svgs/noto-serif-thai.svg";
import svg_noto_serif_tibetan from "@/assets/font-svgs/noto-serif-tibetan.svg";
import svg_noto_serif_toto from "@/assets/font-svgs/noto-serif-toto.svg";
import svg_noto_serif_vithkuqi from "@/assets/font-svgs/noto-serif-vithkuqi.svg";
import svg_noto_serif_yezidi from "@/assets/font-svgs/noto-serif-yezidi.svg";
import svg_noto_serif from "@/assets/font-svgs/noto-serif.svg";
import svg_noto_traditional_nushu from "@/assets/font-svgs/noto-traditional-nushu.svg";
import svg_nova_cut from "@/assets/font-svgs/nova-cut.svg";
import svg_nova_flat from "@/assets/font-svgs/nova-flat.svg";
import svg_nova_mono from "@/assets/font-svgs/nova-mono.svg";
import svg_nova_oval from "@/assets/font-svgs/nova-oval.svg";
import svg_nova_round from "@/assets/font-svgs/nova-round.svg";
import svg_nova_script from "@/assets/font-svgs/nova-script.svg";
import svg_nova_slim from "@/assets/font-svgs/nova-slim.svg";
import svg_nova_square from "@/assets/font-svgs/nova-square.svg";
import svg_ntr from "@/assets/font-svgs/ntr.svg";
import svg_numans from "@/assets/font-svgs/numans.svg";
import svg_nunito_sans from "@/assets/font-svgs/nunito-sans.svg";
import svg_nunito from "@/assets/font-svgs/nunito.svg";
import svg_nuosu_sil from "@/assets/font-svgs/nuosu-sil.svg";
import svg_odibee_sans from "@/assets/font-svgs/odibee-sans.svg";
import svg_odor_mean_chey from "@/assets/font-svgs/odor-mean-chey.svg";
import svg_offside from "@/assets/font-svgs/offside.svg";
import svg_oi from "@/assets/font-svgs/oi.svg";
import svg_old_standard_tt from "@/assets/font-svgs/old-standard-tt.svg";
import svg_oldenburg from "@/assets/font-svgs/oldenburg.svg";
import svg_ole from "@/assets/font-svgs/ole.svg";
import svg_oleo_script_swash_caps from "@/assets/font-svgs/oleo-script-swash-caps.svg";
import svg_oleo_script from "@/assets/font-svgs/oleo-script.svg";
import svg_onest from "@/assets/font-svgs/onest.svg";
import svg_oooh_baby from "@/assets/font-svgs/oooh-baby.svg";
import svg_open_sans from "@/assets/font-svgs/open-sans.svg";
import svg_oranienbaum from "@/assets/font-svgs/oranienbaum.svg";
import svg_orbit from "@/assets/font-svgs/orbit.svg";
import svg_orbitron from "@/assets/font-svgs/orbitron.svg";
import svg_oregano from "@/assets/font-svgs/oregano.svg";
import svg_orelega_one from "@/assets/font-svgs/orelega-one.svg";
import svg_orienta from "@/assets/font-svgs/orienta.svg";
import svg_original_surfer from "@/assets/font-svgs/original-surfer.svg";
import svg_oswald from "@/assets/font-svgs/oswald.svg";
import svg_outfit from "@/assets/font-svgs/outfit.svg";
import svg_over_the_rainbow from "@/assets/font-svgs/over-the-rainbow.svg";
import svg_overlock_sc from "@/assets/font-svgs/overlock-sc.svg";
import svg_overlock from "@/assets/font-svgs/overlock.svg";
import svg_overpass_mono from "@/assets/font-svgs/overpass-mono.svg";
import svg_overpass from "@/assets/font-svgs/overpass.svg";
import svg_ovo from "@/assets/font-svgs/ovo.svg";
import svg_oxanium from "@/assets/font-svgs/oxanium.svg";
import svg_oxygen_mono from "@/assets/font-svgs/oxygen-mono.svg";
import svg_oxygen from "@/assets/font-svgs/oxygen.svg";
import svg_pacifico from "@/assets/font-svgs/pacifico.svg";
import svg_padauk from "@/assets/font-svgs/padauk.svg";
import svg_padyakke_expanded_one from "@/assets/font-svgs/padyakke-expanded-one.svg";
import svg_palanquin_dark from "@/assets/font-svgs/palanquin-dark.svg";
import svg_palanquin from "@/assets/font-svgs/palanquin.svg";
import svg_palette_mosaic from "@/assets/font-svgs/palette-mosaic.svg";
import svg_pangolin from "@/assets/font-svgs/pangolin.svg";
import svg_paprika from "@/assets/font-svgs/paprika.svg";
import svg_parisienne from "@/assets/font-svgs/parisienne.svg";
import svg_passero_one from "@/assets/font-svgs/passero-one.svg";
import svg_passion_one from "@/assets/font-svgs/passion-one.svg";
import svg_passions_conflict from "@/assets/font-svgs/passions-conflict.svg";
import svg_pathway_extreme from "@/assets/font-svgs/pathway-extreme.svg";
import svg_pathway_gothic_one from "@/assets/font-svgs/pathway-gothic-one.svg";
import svg_patrick_hand_sc from "@/assets/font-svgs/patrick-hand-sc.svg";
import svg_patrick_hand from "@/assets/font-svgs/patrick-hand.svg";
import svg_pattaya from "@/assets/font-svgs/pattaya.svg";
import svg_patua_one from "@/assets/font-svgs/patua-one.svg";
import svg_pavanam from "@/assets/font-svgs/pavanam.svg";
import svg_paytone_one from "@/assets/font-svgs/paytone-one.svg";
import svg_peddana from "@/assets/font-svgs/peddana.svg";
import svg_peralta from "@/assets/font-svgs/peralta.svg";
import svg_permanent_marker from "@/assets/font-svgs/permanent-marker.svg";
import svg_petemoss from "@/assets/font-svgs/petemoss.svg";
import svg_petit_formal_script from "@/assets/font-svgs/petit-formal-script.svg";
import svg_petrona from "@/assets/font-svgs/petrona.svg";
import svg_philosopher from "@/assets/font-svgs/philosopher.svg";
import svg_phudu from "@/assets/font-svgs/phudu.svg";
import svg_piazzolla from "@/assets/font-svgs/piazzolla.svg";
import svg_piedra from "@/assets/font-svgs/piedra.svg";
import svg_pinyon_script from "@/assets/font-svgs/pinyon-script.svg";
import svg_pirata_one from "@/assets/font-svgs/pirata-one.svg";
import svg_pixelify_sans from "@/assets/font-svgs/pixelify-sans.svg";
import svg_plaster from "@/assets/font-svgs/plaster.svg";
import svg_play from "@/assets/font-svgs/play.svg";
import svg_playball from "@/assets/font-svgs/playball.svg";
import svg_playfair_display_sc from "@/assets/font-svgs/playfair-display-sc.svg";
import svg_playfair_display from "@/assets/font-svgs/playfair-display.svg";
import svg_playfair from "@/assets/font-svgs/playfair.svg";
import svg_playpen_sans from "@/assets/font-svgs/playpen-sans.svg";
import svg_plus_jakarta_sans from "@/assets/font-svgs/plus-jakarta-sans.svg";
import svg_podkova from "@/assets/font-svgs/podkova.svg";
import svg_poiret_one from "@/assets/font-svgs/poiret-one.svg";
import svg_poller_one from "@/assets/font-svgs/poller-one.svg";
import svg_poltawski_nowy from "@/assets/font-svgs/poltawski-nowy.svg";
import svg_poly from "@/assets/font-svgs/poly.svg";
import svg_pompiere from "@/assets/font-svgs/pompiere.svg";
import svg_pontano_sans from "@/assets/font-svgs/pontano-sans.svg";
import svg_poor_story from "@/assets/font-svgs/poor-story.svg";
import svg_poppins from "@/assets/font-svgs/poppins.svg";
import svg_port_lligat_sans from "@/assets/font-svgs/port-lligat-sans.svg";
import svg_port_lligat_slab from "@/assets/font-svgs/port-lligat-slab.svg";
import svg_potta_one from "@/assets/font-svgs/potta-one.svg";
import svg_pragati_narrow from "@/assets/font-svgs/pragati-narrow.svg";
import svg_praise from "@/assets/font-svgs/praise.svg";
import svg_prata from "@/assets/font-svgs/prata.svg";
import svg_preahvihear from "@/assets/font-svgs/preahvihear.svg";
import svg_press_start_2p from "@/assets/font-svgs/press-start-2p.svg";
import svg_pridi from "@/assets/font-svgs/pridi.svg";
import svg_princess_sofia from "@/assets/font-svgs/princess-sofia.svg";
import svg_prociono from "@/assets/font-svgs/prociono.svg";
import svg_prompt from "@/assets/font-svgs/prompt.svg";
import svg_prosto_one from "@/assets/font-svgs/prosto-one.svg";
import svg_proza_libre from "@/assets/font-svgs/proza-libre.svg";
import svg_pt_mono from "@/assets/font-svgs/pt-mono.svg";
import svg_pt_sans_caption from "@/assets/font-svgs/pt-sans-caption.svg";
import svg_pt_sans_narrow from "@/assets/font-svgs/pt-sans-narrow.svg";
import svg_pt_sans from "@/assets/font-svgs/pt-sans.svg";
import svg_pt_serif_caption from "@/assets/font-svgs/pt-serif-caption.svg";
import svg_pt_serif from "@/assets/font-svgs/pt-serif.svg";
import svg_public_sans from "@/assets/font-svgs/public-sans.svg";
import svg_puppies_play from "@/assets/font-svgs/puppies-play.svg";
import svg_puritan from "@/assets/font-svgs/puritan.svg";
import svg_purple_purse from "@/assets/font-svgs/purple-purse.svg";
import svg_qahiri from "@/assets/font-svgs/qahiri.svg";
import svg_quando from "@/assets/font-svgs/quando.svg";
import svg_quantico from "@/assets/font-svgs/quantico.svg";
import svg_quattrocento_sans from "@/assets/font-svgs/quattrocento-sans.svg";
import svg_quattrocento from "@/assets/font-svgs/quattrocento.svg";
import svg_questrial from "@/assets/font-svgs/questrial.svg";
import svg_quicksand from "@/assets/font-svgs/quicksand.svg";
import svg_quintessential from "@/assets/font-svgs/quintessential.svg";
import svg_qwigley from "@/assets/font-svgs/qwigley.svg";
import svg_qwitcher_grypen from "@/assets/font-svgs/qwitcher-grypen.svg";
import svg_racing_sans_one from "@/assets/font-svgs/racing-sans-one.svg";
import svg_radio_canada from "@/assets/font-svgs/radio-canada.svg";
import svg_radley from "@/assets/font-svgs/radley.svg";
import svg_rajdhani from "@/assets/font-svgs/rajdhani.svg";
import svg_rakkas from "@/assets/font-svgs/rakkas.svg";
import svg_raleway_dots from "@/assets/font-svgs/raleway-dots.svg";
import svg_raleway from "@/assets/font-svgs/raleway.svg";
import svg_ramabhadra from "@/assets/font-svgs/ramabhadra.svg";
import svg_ramaraja from "@/assets/font-svgs/ramaraja.svg";
import svg_rambla from "@/assets/font-svgs/rambla.svg";
import svg_rammetto_one from "@/assets/font-svgs/rammetto-one.svg";
import svg_rampart_one from "@/assets/font-svgs/rampart-one.svg";
import svg_ranchers from "@/assets/font-svgs/ranchers.svg";
import svg_rancho from "@/assets/font-svgs/rancho.svg";
import svg_ranga from "@/assets/font-svgs/ranga.svg";
import svg_rasa from "@/assets/font-svgs/rasa.svg";
import svg_rationale from "@/assets/font-svgs/rationale.svg";
import svg_ravi_prakash from "@/assets/font-svgs/ravi-prakash.svg";
import svg_readex_pro from "@/assets/font-svgs/readex-pro.svg";
import svg_recursive from "@/assets/font-svgs/recursive.svg";
import svg_red_hat_display from "@/assets/font-svgs/red-hat-display.svg";
import svg_red_hat_mono from "@/assets/font-svgs/red-hat-mono.svg";
import svg_red_hat_text from "@/assets/font-svgs/red-hat-text.svg";
import svg_red_rose from "@/assets/font-svgs/red-rose.svg";
import svg_redacted_script from "@/assets/font-svgs/redacted-script.svg";
import svg_redacted from "@/assets/font-svgs/redacted.svg";
import svg_redressed from "@/assets/font-svgs/redressed.svg";
import svg_reem_kufi_fun from "@/assets/font-svgs/reem-kufi-fun.svg";
import svg_reem_kufi_ink from "@/assets/font-svgs/reem-kufi-ink.svg";
import svg_reem_kufi from "@/assets/font-svgs/reem-kufi.svg";
import svg_reenie_beanie from "@/assets/font-svgs/reenie-beanie.svg";
import svg_reggae_one from "@/assets/font-svgs/reggae-one.svg";
import svg_rem from "@/assets/font-svgs/rem.svg";
import svg_rethink_sans from "@/assets/font-svgs/rethink-sans.svg";
import svg_revalia from "@/assets/font-svgs/revalia.svg";
import svg_rhodium_libre from "@/assets/font-svgs/rhodium-libre.svg";
import svg_ribeye_marrow from "@/assets/font-svgs/ribeye-marrow.svg";
import svg_ribeye from "@/assets/font-svgs/ribeye.svg";
import svg_righteous from "@/assets/font-svgs/righteous.svg";
import svg_risque from "@/assets/font-svgs/risque.svg";
import svg_road_rage from "@/assets/font-svgs/road-rage.svg";
import svg_roboto_condensed from "@/assets/font-svgs/roboto-condensed.svg";
import svg_roboto_flex from "@/assets/font-svgs/roboto-flex.svg";
import svg_roboto_mono from "@/assets/font-svgs/roboto-mono.svg";
import svg_roboto_serif from "@/assets/font-svgs/roboto-serif.svg";
import svg_roboto_slab from "@/assets/font-svgs/roboto-slab.svg";
import svg_roboto from "@/assets/font-svgs/roboto.svg";
import svg_rochester from "@/assets/font-svgs/rochester.svg";
import svg_rock_3d from "@/assets/font-svgs/rock-3d.svg";
import svg_rock_salt from "@/assets/font-svgs/rock-salt.svg";
import svg_rocknroll_one from "@/assets/font-svgs/rocknroll-one.svg";
import svg_rokkitt from "@/assets/font-svgs/rokkitt.svg";
import svg_romanesco from "@/assets/font-svgs/romanesco.svg";
import svg_ropa_sans from "@/assets/font-svgs/ropa-sans.svg";
import svg_rosario from "@/assets/font-svgs/rosario.svg";
import svg_rosarivo from "@/assets/font-svgs/rosarivo.svg";
import svg_rouge_script from "@/assets/font-svgs/rouge-script.svg";
import svg_rowdies from "@/assets/font-svgs/rowdies.svg";
import svg_rozha_one from "@/assets/font-svgs/rozha-one.svg";
import svg_rubik_80s_fade from "@/assets/font-svgs/rubik-80s-fade.svg";
import svg_rubik_beastly from "@/assets/font-svgs/rubik-beastly.svg";
import svg_rubik_broken_fax from "@/assets/font-svgs/rubik-broken-fax.svg";
import svg_rubik_bubbles from "@/assets/font-svgs/rubik-bubbles.svg";
import svg_rubik_burned from "@/assets/font-svgs/rubik-burned.svg";
import svg_rubik_dirt from "@/assets/font-svgs/rubik-dirt.svg";
import svg_rubik_distressed from "@/assets/font-svgs/rubik-distressed.svg";
import svg_rubik_doodle_shadow from "@/assets/font-svgs/rubik-doodle-shadow.svg";
import svg_rubik_doodle_triangles from "@/assets/font-svgs/rubik-doodle-triangles.svg";
import svg_rubik_gemstones from "@/assets/font-svgs/rubik-gemstones.svg";
import svg_rubik_glitch from "@/assets/font-svgs/rubik-glitch.svg";
import svg_rubik_iso from "@/assets/font-svgs/rubik-iso.svg";
import svg_rubik_lines from "@/assets/font-svgs/rubik-lines.svg";
import svg_rubik_maps from "@/assets/font-svgs/rubik-maps.svg";
import svg_rubik_marker_hatch from "@/assets/font-svgs/rubik-marker-hatch.svg";
import svg_rubik_maze from "@/assets/font-svgs/rubik-maze.svg";
import svg_rubik_microbe from "@/assets/font-svgs/rubik-microbe.svg";
import svg_rubik_mono_one from "@/assets/font-svgs/rubik-mono-one.svg";
import svg_rubik_moonrocks from "@/assets/font-svgs/rubik-moonrocks.svg";
import svg_rubik_pixels from "@/assets/font-svgs/rubik-pixels.svg";
import svg_rubik_puddles from "@/assets/font-svgs/rubik-puddles.svg";
import svg_rubik_scribble from "@/assets/font-svgs/rubik-scribble.svg";
import svg_rubik_spray_paint from "@/assets/font-svgs/rubik-spray-paint.svg";
import svg_rubik_storm from "@/assets/font-svgs/rubik-storm.svg";
import svg_rubik_vinyl from "@/assets/font-svgs/rubik-vinyl.svg";
import svg_rubik_wet_paint from "@/assets/font-svgs/rubik-wet-paint.svg";
import svg_rubik from "@/assets/font-svgs/rubik.svg";
import svg_ruda from "@/assets/font-svgs/ruda.svg";
import svg_rufina from "@/assets/font-svgs/rufina.svg";
import svg_ruge_boogie from "@/assets/font-svgs/ruge-boogie.svg";
import svg_ruluko from "@/assets/font-svgs/ruluko.svg";
import svg_rum_raisin from "@/assets/font-svgs/rum-raisin.svg";
import svg_ruslan_display from "@/assets/font-svgs/ruslan-display.svg";
import svg_russo_one from "@/assets/font-svgs/russo-one.svg";
import svg_ruthie from "@/assets/font-svgs/ruthie.svg";
import svg_ruwudu from "@/assets/font-svgs/ruwudu.svg";
import svg_rye from "@/assets/font-svgs/rye.svg";
import svg_sacramento from "@/assets/font-svgs/sacramento.svg";
import svg_sahitya from "@/assets/font-svgs/sahitya.svg";
import svg_sail from "@/assets/font-svgs/sail.svg";
import svg_saira_condensed from "@/assets/font-svgs/saira-condensed.svg";
import svg_saira_extra_condensed from "@/assets/font-svgs/saira-extra-condensed.svg";
import svg_saira_semi_condensed from "@/assets/font-svgs/saira-semi-condensed.svg";
import svg_saira_stencil_one from "@/assets/font-svgs/saira-stencil-one.svg";
import svg_saira from "@/assets/font-svgs/saira.svg";
import svg_salsa from "@/assets/font-svgs/salsa.svg";
import svg_sanchez from "@/assets/font-svgs/sanchez.svg";
import svg_sancreek from "@/assets/font-svgs/sancreek.svg";
import svg_sansita_swashed from "@/assets/font-svgs/sansita-swashed.svg";
import svg_sansita from "@/assets/font-svgs/sansita.svg";
import svg_sarabun from "@/assets/font-svgs/sarabun.svg";
import svg_sarala from "@/assets/font-svgs/sarala.svg";
import svg_sarina from "@/assets/font-svgs/sarina.svg";
import svg_sarpanch from "@/assets/font-svgs/sarpanch.svg";
import svg_sassy_frass from "@/assets/font-svgs/sassy-frass.svg";
import svg_satisfy from "@/assets/font-svgs/satisfy.svg";
import svg_sawarabi_gothic from "@/assets/font-svgs/sawarabi-gothic.svg";
import svg_sawarabi_mincho from "@/assets/font-svgs/sawarabi-mincho.svg";
import svg_scada from "@/assets/font-svgs/scada.svg";
import svg_scheherazade_new from "@/assets/font-svgs/scheherazade-new.svg";
import svg_schibsted_grotesk from "@/assets/font-svgs/schibsted-grotesk.svg";
import svg_schoolbell from "@/assets/font-svgs/schoolbell.svg";
import svg_scope_one from "@/assets/font-svgs/scope-one.svg";
import svg_seaweed_script from "@/assets/font-svgs/seaweed-script.svg";
import svg_secular_one from "@/assets/font-svgs/secular-one.svg";
import svg_sedgwick_ave_display from "@/assets/font-svgs/sedgwick-ave-display.svg";
import svg_sedgwick_ave from "@/assets/font-svgs/sedgwick-ave.svg";
import svg_sen from "@/assets/font-svgs/sen.svg";
import svg_send_flowers from "@/assets/font-svgs/send-flowers.svg";
import svg_sevillana from "@/assets/font-svgs/sevillana.svg";
import svg_seymour_one from "@/assets/font-svgs/seymour-one.svg";
import svg_shadows_into_light_two from "@/assets/font-svgs/shadows-into-light-two.svg";
import svg_shadows_into_light from "@/assets/font-svgs/shadows-into-light.svg";
import svg_shalimar from "@/assets/font-svgs/shalimar.svg";
import svg_shantell_sans from "@/assets/font-svgs/shantell-sans.svg";
import svg_shanti from "@/assets/font-svgs/shanti.svg";
import svg_share_tech_mono from "@/assets/font-svgs/share-tech-mono.svg";
import svg_share_tech from "@/assets/font-svgs/share-tech.svg";
import svg_share from "@/assets/font-svgs/share.svg";
import svg_shippori_antique_b1 from "@/assets/font-svgs/shippori-antique-b1.svg";
import svg_shippori_antique from "@/assets/font-svgs/shippori-antique.svg";
import svg_shippori_mincho_b1 from "@/assets/font-svgs/shippori-mincho-b1.svg";
import svg_shippori_mincho from "@/assets/font-svgs/shippori-mincho.svg";
import svg_shizuru from "@/assets/font-svgs/shizuru.svg";
import svg_shojumaru from "@/assets/font-svgs/shojumaru.svg";
import svg_short_stack from "@/assets/font-svgs/short-stack.svg";
import svg_shrikhand from "@/assets/font-svgs/shrikhand.svg";
import svg_siemreap from "@/assets/font-svgs/siemreap.svg";
import svg_sigmar_one from "@/assets/font-svgs/sigmar-one.svg";
import svg_sigmar from "@/assets/font-svgs/sigmar.svg";
import svg_signika_negative from "@/assets/font-svgs/signika-negative.svg";
import svg_signika from "@/assets/font-svgs/signika.svg";
import svg_silkscreen from "@/assets/font-svgs/silkscreen.svg";
import svg_simonetta from "@/assets/font-svgs/simonetta.svg";
import svg_single_day from "@/assets/font-svgs/single-day.svg";
import svg_sintony from "@/assets/font-svgs/sintony.svg";
import svg_sirin_stencil from "@/assets/font-svgs/sirin-stencil.svg";
import svg_six_caps from "@/assets/font-svgs/six-caps.svg";
import svg_skranji from "@/assets/font-svgs/skranji.svg";
import svg_slabo_13px from "@/assets/font-svgs/slabo-13px.svg";
import svg_slabo_27px from "@/assets/font-svgs/slabo-27px.svg";
import svg_slackey from "@/assets/font-svgs/slackey.svg";
import svg_slackside_one from "@/assets/font-svgs/slackside-one.svg";
import svg_smokum from "@/assets/font-svgs/smokum.svg";
import svg_smooch_sans from "@/assets/font-svgs/smooch-sans.svg";
import svg_smooch from "@/assets/font-svgs/smooch.svg";
import svg_smythe from "@/assets/font-svgs/smythe.svg";
import svg_sniglet from "@/assets/font-svgs/sniglet.svg";
import svg_snippet from "@/assets/font-svgs/snippet.svg";
import svg_snowburst_one from "@/assets/font-svgs/snowburst-one.svg";
import svg_sofadi_one from "@/assets/font-svgs/sofadi-one.svg";
import svg_sofia_sans_condensed from "@/assets/font-svgs/sofia-sans-condensed.svg";
import svg_sofia_sans_extra_condensed from "@/assets/font-svgs/sofia-sans-extra-condensed.svg";
import svg_sofia_sans_semi_condensed from "@/assets/font-svgs/sofia-sans-semi-condensed.svg";
import svg_sofia_sans from "@/assets/font-svgs/sofia-sans.svg";
import svg_sofia from "@/assets/font-svgs/sofia.svg";
import svg_solitreo from "@/assets/font-svgs/solitreo.svg";
import svg_solway from "@/assets/font-svgs/solway.svg";
import svg_sometype_mono from "@/assets/font-svgs/sometype-mono.svg";
import svg_song_myung from "@/assets/font-svgs/song-myung.svg";
import svg_sono from "@/assets/font-svgs/sono.svg";
import svg_sonsie_one from "@/assets/font-svgs/sonsie-one.svg";
import svg_sora from "@/assets/font-svgs/sora.svg";
import svg_sorts_mill_goudy from "@/assets/font-svgs/sorts-mill-goudy.svg";
import svg_source_code_pro from "@/assets/font-svgs/source-code-pro.svg";
import svg_source_sans_3 from "@/assets/font-svgs/source-sans-3.svg";
import svg_source_serif_4 from "@/assets/font-svgs/source-serif-4.svg";
import svg_space_grotesk from "@/assets/font-svgs/space-grotesk.svg";
import svg_space_mono from "@/assets/font-svgs/space-mono.svg";
import svg_special_elite from "@/assets/font-svgs/special-elite.svg";
import svg_spectral_sc from "@/assets/font-svgs/spectral-sc.svg";
import svg_spectral from "@/assets/font-svgs/spectral.svg";
import svg_spicy_rice from "@/assets/font-svgs/spicy-rice.svg";
import svg_spinnaker from "@/assets/font-svgs/spinnaker.svg";
import svg_spirax from "@/assets/font-svgs/spirax.svg";
import svg_splash from "@/assets/font-svgs/splash.svg";
import svg_spline_sans_mono from "@/assets/font-svgs/spline-sans-mono.svg";
import svg_spline_sans from "@/assets/font-svgs/spline-sans.svg";
import svg_squada_one from "@/assets/font-svgs/squada-one.svg";
import svg_square_peg from "@/assets/font-svgs/square-peg.svg";
import svg_sree_krushnadevaraya from "@/assets/font-svgs/sree-krushnadevaraya.svg";
import svg_sriracha from "@/assets/font-svgs/sriracha.svg";
import svg_srisakdi from "@/assets/font-svgs/srisakdi.svg";
import svg_staatliches from "@/assets/font-svgs/staatliches.svg";
import svg_stalemate from "@/assets/font-svgs/stalemate.svg";
import svg_stalinist_one from "@/assets/font-svgs/stalinist-one.svg";
import svg_stardos_stencil from "@/assets/font-svgs/stardos-stencil.svg";
import svg_stick_no_bills from "@/assets/font-svgs/stick-no-bills.svg";
import svg_stick from "@/assets/font-svgs/stick.svg";
import svg_stint_ultra_condensed from "@/assets/font-svgs/stint-ultra-condensed.svg";
import svg_stint_ultra_expanded from "@/assets/font-svgs/stint-ultra-expanded.svg";
import svg_stix_two_text from "@/assets/font-svgs/stix-two-text.svg";
import svg_stoke from "@/assets/font-svgs/stoke.svg";
import svg_strait from "@/assets/font-svgs/strait.svg";
import svg_style_script from "@/assets/font-svgs/style-script.svg";
import svg_stylish from "@/assets/font-svgs/stylish.svg";
import svg_sue_ellen_francisco from "@/assets/font-svgs/sue-ellen-francisco.svg";
import svg_suez_one from "@/assets/font-svgs/suez-one.svg";
import svg_sulphur_point from "@/assets/font-svgs/sulphur-point.svg";
import svg_sumana from "@/assets/font-svgs/sumana.svg";
import svg_sunshiney from "@/assets/font-svgs/sunshiney.svg";
import svg_supermercado_one from "@/assets/font-svgs/supermercado-one.svg";
import svg_sura from "@/assets/font-svgs/sura.svg";
import svg_suranna from "@/assets/font-svgs/suranna.svg";
import svg_suravaram from "@/assets/font-svgs/suravaram.svg";
import svg_suwannaphum from "@/assets/font-svgs/suwannaphum.svg";
import svg_swanky_and_moo_moo from "@/assets/font-svgs/swanky-and-moo-moo.svg";
import svg_syncopate from "@/assets/font-svgs/syncopate.svg";
import svg_syne_mono from "@/assets/font-svgs/syne-mono.svg";
import svg_syne_tactile from "@/assets/font-svgs/syne-tactile.svg";
import svg_syne from "@/assets/font-svgs/syne.svg";
import svg_tai_heritage_pro from "@/assets/font-svgs/tai-heritage-pro.svg";
import svg_tajawal from "@/assets/font-svgs/tajawal.svg";
import svg_tangerine from "@/assets/font-svgs/tangerine.svg";
import svg_tapestry from "@/assets/font-svgs/tapestry.svg";
import svg_taprom from "@/assets/font-svgs/taprom.svg";
import svg_tauri from "@/assets/font-svgs/tauri.svg";
import svg_taviraj from "@/assets/font-svgs/taviraj.svg";
import svg_teko from "@/assets/font-svgs/teko.svg";
import svg_tektur from "@/assets/font-svgs/tektur.svg";
import svg_telex from "@/assets/font-svgs/telex.svg";
import svg_tenali_ramakrishna from "@/assets/font-svgs/tenali-ramakrishna.svg";
import svg_tenor_sans from "@/assets/font-svgs/tenor-sans.svg";
import svg_text_me_one from "@/assets/font-svgs/text-me-one.svg";
import svg_texturina from "@/assets/font-svgs/texturina.svg";
import svg_thasadith from "@/assets/font-svgs/thasadith.svg";
import svg_the_girl_next_door from "@/assets/font-svgs/the-girl-next-door.svg";
import svg_the_nautigal from "@/assets/font-svgs/the-nautigal.svg";
import svg_tienne from "@/assets/font-svgs/tienne.svg";
import svg_tillana from "@/assets/font-svgs/tillana.svg";
import svg_tilt_neon from "@/assets/font-svgs/tilt-neon.svg";
import svg_tilt_prism from "@/assets/font-svgs/tilt-prism.svg";
import svg_tilt_warp from "@/assets/font-svgs/tilt-warp.svg";
import svg_timmana from "@/assets/font-svgs/timmana.svg";
import svg_tinos from "@/assets/font-svgs/tinos.svg";
import svg_tiro_bangla from "@/assets/font-svgs/tiro-bangla.svg";
import svg_tiro_devanagari_hindi from "@/assets/font-svgs/tiro-devanagari-hindi.svg";
import svg_tiro_devanagari_marathi from "@/assets/font-svgs/tiro-devanagari-marathi.svg";
import svg_tiro_devanagari_sanskrit from "@/assets/font-svgs/tiro-devanagari-sanskrit.svg";
import svg_tiro_gurmukhi from "@/assets/font-svgs/tiro-gurmukhi.svg";
import svg_tiro_kannada from "@/assets/font-svgs/tiro-kannada.svg";
import svg_tiro_tamil from "@/assets/font-svgs/tiro-tamil.svg";
import svg_tiro_telugu from "@/assets/font-svgs/tiro-telugu.svg";
import svg_titan_one from "@/assets/font-svgs/titan-one.svg";
import svg_titillium_web from "@/assets/font-svgs/titillium-web.svg";
import svg_tomorrow from "@/assets/font-svgs/tomorrow.svg";
import svg_tourney from "@/assets/font-svgs/tourney.svg";
import svg_trade_winds from "@/assets/font-svgs/trade-winds.svg";
import svg_train_one from "@/assets/font-svgs/train-one.svg";
import svg_trirong from "@/assets/font-svgs/trirong.svg";
import svg_trispace from "@/assets/font-svgs/trispace.svg";
import svg_trocchi from "@/assets/font-svgs/trocchi.svg";
import svg_trochut from "@/assets/font-svgs/trochut.svg";
import svg_truculenta from "@/assets/font-svgs/truculenta.svg";
import svg_trykker from "@/assets/font-svgs/trykker.svg";
import svg_tsukimi_rounded from "@/assets/font-svgs/tsukimi-rounded.svg";
import svg_tulpen_one from "@/assets/font-svgs/tulpen-one.svg";
import svg_turret_road from "@/assets/font-svgs/turret-road.svg";
import svg_twinkle_star from "@/assets/font-svgs/twinkle-star.svg";
import svg_ubuntu_condensed from "@/assets/font-svgs/ubuntu-condensed.svg";
import svg_ubuntu_mono from "@/assets/font-svgs/ubuntu-mono.svg";
import svg_ubuntu from "@/assets/font-svgs/ubuntu.svg";
import svg_uchen from "@/assets/font-svgs/uchen.svg";
import svg_ultra from "@/assets/font-svgs/ultra.svg";
import svg_unbounded from "@/assets/font-svgs/unbounded.svg";
import svg_uncial_antiqua from "@/assets/font-svgs/uncial-antiqua.svg";
import svg_underdog from "@/assets/font-svgs/underdog.svg";
import svg_unica_one from "@/assets/font-svgs/unica-one.svg";
import svg_unifrakturmaguntia from "@/assets/font-svgs/unifrakturmaguntia.svg";
import svg_unkempt from "@/assets/font-svgs/unkempt.svg";
import svg_unlock from "@/assets/font-svgs/unlock.svg";
import svg_unna from "@/assets/font-svgs/unna.svg";
import svg_updock from "@/assets/font-svgs/updock.svg";
import svg_urbanist from "@/assets/font-svgs/urbanist.svg";
import svg_vampiro_one from "@/assets/font-svgs/vampiro-one.svg";
import svg_varela_round from "@/assets/font-svgs/varela-round.svg";
import svg_varela from "@/assets/font-svgs/varela.svg";
import svg_varta from "@/assets/font-svgs/varta.svg";
import svg_vast_shadow from "@/assets/font-svgs/vast-shadow.svg";
import svg_vazirmatn from "@/assets/font-svgs/vazirmatn.svg";
import svg_vesper_libre from "@/assets/font-svgs/vesper-libre.svg";
import svg_viaoda_libre from "@/assets/font-svgs/viaoda-libre.svg";
import svg_vibes from "@/assets/font-svgs/vibes.svg";
import svg_vibur from "@/assets/font-svgs/vibur.svg";
import svg_victor_mono from "@/assets/font-svgs/victor-mono.svg";
import svg_vidaloka from "@/assets/font-svgs/vidaloka.svg";
import svg_viga from "@/assets/font-svgs/viga.svg";
import svg_vina_sans from "@/assets/font-svgs/vina-sans.svg";
import svg_voces from "@/assets/font-svgs/voces.svg";
import svg_volkhov from "@/assets/font-svgs/volkhov.svg";
import svg_vollkorn_sc from "@/assets/font-svgs/vollkorn-sc.svg";
import svg_vollkorn from "@/assets/font-svgs/vollkorn.svg";
import svg_voltaire from "@/assets/font-svgs/voltaire.svg";
import svg_vt323 from "@/assets/font-svgs/vt323.svg";
import svg_vujahday_script from "@/assets/font-svgs/vujahday-script.svg";
import svg_waiting_for_the_sunrise from "@/assets/font-svgs/waiting-for-the-sunrise.svg";
import svg_wallpoet from "@/assets/font-svgs/wallpoet.svg";
import svg_walter_turncoat from "@/assets/font-svgs/walter-turncoat.svg";
import svg_warnes from "@/assets/font-svgs/warnes.svg";
import svg_water_brush from "@/assets/font-svgs/water-brush.svg";
import svg_waterfall from "@/assets/font-svgs/waterfall.svg";
import svg_wavefont from "@/assets/font-svgs/wavefont.svg";
import svg_wellfleet from "@/assets/font-svgs/wellfleet.svg";
import svg_wendy_one from "@/assets/font-svgs/wendy-one.svg";
import svg_whisper from "@/assets/font-svgs/whisper.svg";

export const FONT_SVG_PREVIEW_ASSETS: Record<string, string> = {
  "abeezee": svg_abeezee,
  "abel": svg_abel,
  "abhaya-libre": svg_abhaya_libre,
  "aboreto": svg_aboreto,
  "abril-fatface": svg_abril_fatface,
  "abyssinica-sil": svg_abyssinica_sil,
  "aclonica": svg_aclonica,
  "acme": svg_acme,
  "actor": svg_actor,
  "adamina": svg_adamina,
  "adlam-display": svg_adlam_display,
  "advent-pro": svg_advent_pro,
  "afacad": svg_afacad,
  "agbalumo": svg_agbalumo,
  "agdasima": svg_agdasima,
  "aguafina-script": svg_aguafina_script,
  "akatab": svg_akatab,
  "akaya-kanadaka": svg_akaya_kanadaka,
  "akaya-telivigala": svg_akaya_telivigala,
  "akronim": svg_akronim,
  "akshar": svg_akshar,
  "aladin": svg_aladin,
  "alata": svg_alata,
  "alatsi": svg_alatsi,
  "albert-sans": svg_albert_sans,
  "aldrich": svg_aldrich,
  "alef": svg_alef,
  "alegreya-sans-sc": svg_alegreya_sans_sc,
  "alegreya-sans": svg_alegreya_sans,
  "alegreya-sc": svg_alegreya_sc,
  "alegreya": svg_alegreya,
  "aleo": svg_aleo,
  "alex-brush": svg_alex_brush,
  "alexandria": svg_alexandria,
  "alfa-slab-one": svg_alfa_slab_one,
  "alice": svg_alice,
  "alike-angular": svg_alike_angular,
  "alike": svg_alike,
  "alkalami": svg_alkalami,
  "alkatra": svg_alkatra,
  "allan": svg_allan,
  "allerta-stencil": svg_allerta_stencil,
  "allerta": svg_allerta,
  "allison": svg_allison,
  "allura": svg_allura,
  "almarai": svg_almarai,
  "almendra-display": svg_almendra_display,
  "almendra-sc": svg_almendra_sc,
  "almendra": svg_almendra,
  "alumni-sans-collegiate-one": svg_alumni_sans_collegiate_one,
  "alumni-sans-inline-one": svg_alumni_sans_inline_one,
  "alumni-sans-pinstripe": svg_alumni_sans_pinstripe,
  "alumni-sans": svg_alumni_sans,
  "amarante": svg_amarante,
  "amaranth": svg_amaranth,
  "amatic-sc": svg_amatic_sc,
  "amethysta": svg_amethysta,
  "amiko": svg_amiko,
  "amiri-quran": svg_amiri_quran,
  "amiri": svg_amiri,
  "amita": svg_amita,
  "anaheim": svg_anaheim,
  "andada-pro": svg_andada_pro,
  "andika": svg_andika,
  "anek-bangla": svg_anek_bangla,
  "anek-devanagari": svg_anek_devanagari,
  "anek-gujarati": svg_anek_gujarati,
  "anek-gurmukhi": svg_anek_gurmukhi,
  "anek-kannada": svg_anek_kannada,
  "anek-latin": svg_anek_latin,
  "anek-malayalam": svg_anek_malayalam,
  "anek-odia": svg_anek_odia,
  "anek-tamil": svg_anek_tamil,
  "anek-telugu": svg_anek_telugu,
  "angkor": svg_angkor,
  "annie-use-your-telescope": svg_annie_use_your_telescope,
  "anonymous-pro": svg_anonymous_pro,
  "antic-didone": svg_antic_didone,
  "antic-slab": svg_antic_slab,
  "antic": svg_antic,
  "anton": svg_anton,
  "antonio": svg_antonio,
  "anuphan": svg_anuphan,
  "anybody": svg_anybody,
  "aoboshi-one": svg_aoboshi_one,
  "ar-one-sans": svg_ar_one_sans,
  "arapey": svg_arapey,
  "arbutus-slab": svg_arbutus_slab,
  "arbutus": svg_arbutus,
  "architects-daughter": svg_architects_daughter,
  "archivo-black": svg_archivo_black,
  "archivo-narrow": svg_archivo_narrow,
  "archivo": svg_archivo,
  "are-you-serious": svg_are_you_serious,
  "aref-ruqaa-ink": svg_aref_ruqaa_ink,
  "aref-ruqaa": svg_aref_ruqaa,
  "arima": svg_arima,
  "arimo": svg_arimo,
  "arizonia": svg_arizonia,
  "armata": svg_armata,
  "arsenal": svg_arsenal,
  "artifika": svg_artifika,
  "arvo": svg_arvo,
  "arya": svg_arya,
  "asap-condensed": svg_asap_condensed,
  "asap": svg_asap,
  "asar": svg_asar,
  "asset": svg_asset,
  "assistant": svg_assistant,
  "astloch": svg_astloch,
  "asul": svg_asul,
  "athiti": svg_athiti,
  "atkinson-hyperlegible": svg_atkinson_hyperlegible,
  "atma": svg_atma,
  "atomic-age": svg_atomic_age,
  "aubrey": svg_aubrey,
  "audiowide": svg_audiowide,
  "autour-one": svg_autour_one,
  "average-sans": svg_average_sans,
  "average": svg_average,
  "averia-gruesa-libre": svg_averia_gruesa_libre,
  "averia-libre": svg_averia_libre,
  "averia-sans-libre": svg_averia_sans_libre,
  "averia-serif-libre": svg_averia_serif_libre,
  "azeret-mono": svg_azeret_mono,
  "b612-mono": svg_b612_mono,
  "b612": svg_b612,
  "babylonica": svg_babylonica,
  "bacasime-antique": svg_bacasime_antique,
  "bad-script": svg_bad_script,
  "bagel-fat-one": svg_bagel_fat_one,
  "bahiana": svg_bahiana,
  "bahianita": svg_bahianita,
  "bai-jamjuree": svg_bai_jamjuree,
  "bakbak-one": svg_bakbak_one,
  "ballet": svg_ballet,
  "baloo-2": svg_baloo_2,
  "baloo-bhai-2": svg_baloo_bhai_2,
  "baloo-bhaijaan-2": svg_baloo_bhaijaan_2,
  "baloo-bhaina-2": svg_baloo_bhaina_2,
  "baloo-chettan-2": svg_baloo_chettan_2,
  "baloo-da-2": svg_baloo_da_2,
  "baloo-paaji-2": svg_baloo_paaji_2,
  "baloo-tamma-2": svg_baloo_tamma_2,
  "baloo-tammudu-2": svg_baloo_tammudu_2,
  "baloo-thambi-2": svg_baloo_thambi_2,
  "balsamiq-sans": svg_balsamiq_sans,
  "balthazar": svg_balthazar,
  "bangers": svg_bangers,
  "barlow-condensed": svg_barlow_condensed,
  "barlow-semi-condensed": svg_barlow_semi_condensed,
  "barlow": svg_barlow,
  "barriecito": svg_barriecito,
  "barrio": svg_barrio,
  "basic": svg_basic,
  "baskervville": svg_baskervville,
  "battambang": svg_battambang,
  "baumans": svg_baumans,
  "bayon": svg_bayon,
  "be-vietnam-pro": svg_be_vietnam_pro,
  "beau-rivage": svg_beau_rivage,
  "bebas-neue": svg_bebas_neue,
  "belanosima": svg_belanosima,
  "belgrano": svg_belgrano,
  "bellefair": svg_bellefair,
  "belleza": svg_belleza,
  "bellota-text": svg_bellota_text,
  "bellota": svg_bellota,
  "benchnine": svg_benchnine,
  "benne": svg_benne,
  "bentham": svg_bentham,
  "berkshire-swash": svg_berkshire_swash,
  "besley": svg_besley,
  "beth-ellen": svg_beth_ellen,
  "bevan": svg_bevan,
  "bhutuka-expanded-one": svg_bhutuka_expanded_one,
  "big-shoulders-display": svg_big_shoulders_display,
  "big-shoulders-inline-display": svg_big_shoulders_inline_display,
  "big-shoulders-inline-text": svg_big_shoulders_inline_text,
  "big-shoulders-stencil-display": svg_big_shoulders_stencil_display,
  "big-shoulders-stencil-text": svg_big_shoulders_stencil_text,
  "big-shoulders-text": svg_big_shoulders_text,
  "bigelow-rules": svg_bigelow_rules,
  "bigshot-one": svg_bigshot_one,
  "bilbo-swash-caps": svg_bilbo_swash_caps,
  "bilbo": svg_bilbo,
  "biorhyme-expanded": svg_biorhyme_expanded,
  "biorhyme": svg_biorhyme,
  "birthstone-bounce": svg_birthstone_bounce,
  "birthstone": svg_birthstone,
  "biryani": svg_biryani,
  "bitter": svg_bitter,
  "biz-udgothic": svg_biz_udgothic,
  "biz-udmincho": svg_biz_udmincho,
  "biz-udpgothic": svg_biz_udpgothic,
  "biz-udpmincho": svg_biz_udpmincho,
  "black-and-white-picture": svg_black_and_white_picture,
  "black-han-sans": svg_black_han_sans,
  "black-ops-one": svg_black_ops_one,
  "blaka-hollow": svg_blaka_hollow,
  "blaka-ink": svg_blaka_ink,
  "blaka": svg_blaka,
  "blinker": svg_blinker,
  "bodoni-moda": svg_bodoni_moda,
  "bokor": svg_bokor,
  "bona-nova": svg_bona_nova,
  "bonbon": svg_bonbon,
  "bonheur-royale": svg_bonheur_royale,
  "boogaloo": svg_boogaloo,
  "borel": svg_borel,
  "bowlby-one-sc": svg_bowlby_one_sc,
  "bowlby-one": svg_bowlby_one,
  "braah-one": svg_braah_one,
  "brawler": svg_brawler,
  "bree-serif": svg_bree_serif,
  "bricolage-grotesque": svg_bricolage_grotesque,
  "bruno-ace-sc": svg_bruno_ace_sc,
  "bruno-ace": svg_bruno_ace,
  "brygada-1918": svg_brygada_1918,
  "bubblegum-sans": svg_bubblegum_sans,
  "bubbler-one": svg_bubbler_one,
  "buenard": svg_buenard,
  "bungee-hairline": svg_bungee_hairline,
  "bungee-inline": svg_bungee_inline,
  "bungee-outline": svg_bungee_outline,
  "bungee-shade": svg_bungee_shade,
  "bungee-spice": svg_bungee_spice,
  "bungee": svg_bungee,
  "butcherman": svg_butcherman,
  "butterfly-kids": svg_butterfly_kids,
  "cabin-condensed": svg_cabin_condensed,
  "cabin-sketch": svg_cabin_sketch,
  "cabin": svg_cabin,
  "caesar-dressing": svg_caesar_dressing,
  "cagliostro": svg_cagliostro,
  "cairo-play": svg_cairo_play,
  "cairo": svg_cairo,
  "caladea": svg_caladea,
  "calistoga": svg_calistoga,
  "calligraffitti": svg_calligraffitti,
  "cambay": svg_cambay,
  "cambo": svg_cambo,
  "candal": svg_candal,
  "cantarell": svg_cantarell,
  "cantata-one": svg_cantata_one,
  "cantora-one": svg_cantora_one,
  "caprasimo": svg_caprasimo,
  "capriola": svg_capriola,
  "caramel": svg_caramel,
  "carattere": svg_carattere,
  "cardo": svg_cardo,
  "carlito": svg_carlito,
  "carme": svg_carme,
  "carrois-gothic-sc": svg_carrois_gothic_sc,
  "carrois-gothic": svg_carrois_gothic,
  "carter-one": svg_carter_one,
  "castoro-titling": svg_castoro_titling,
  "castoro": svg_castoro,
  "catamaran": svg_catamaran,
  "caudex": svg_caudex,
  "caveat-brush": svg_caveat_brush,
  "caveat": svg_caveat,
  "cedarville-cursive": svg_cedarville_cursive,
  "ceviche-one": svg_ceviche_one,
  "chakra-petch": svg_chakra_petch,
  "changa-one": svg_changa_one,
  "changa": svg_changa,
  "chango": svg_chango,
  "charis-sil": svg_charis_sil,
  "charm": svg_charm,
  "charmonman": svg_charmonman,
  "chathura": svg_chathura,
  "chau-philomene-one": svg_chau_philomene_one,
  "chela-one": svg_chela_one,
  "chelsea-market": svg_chelsea_market,
  "chenla": svg_chenla,
  "cherish": svg_cherish,
  "cherry-bomb-one": svg_cherry_bomb_one,
  "cherry-cream-soda": svg_cherry_cream_soda,
  "cherry-swash": svg_cherry_swash,
  "chewy": svg_chewy,
  "chicle": svg_chicle,
  "chilanka": svg_chilanka,
  "chivo-mono": svg_chivo_mono,
  "chivo": svg_chivo,
  "chokokutai": svg_chokokutai,
  "chonburi": svg_chonburi,
  "cinzel-decorative": svg_cinzel_decorative,
  "cinzel": svg_cinzel,
  "clicker-script": svg_clicker_script,
  "climate-crisis": svg_climate_crisis,
  "coda": svg_coda,
  "codystar": svg_codystar,
  "coiny": svg_coiny,
  "combo": svg_combo,
  "comfortaa": svg_comfortaa,
  "comforter-brush": svg_comforter_brush,
  "comforter": svg_comforter,
  "comic-neue": svg_comic_neue,
  "coming-soon": svg_coming_soon,
  "comme": svg_comme,
  "commissioner": svg_commissioner,
  "concert-one": svg_concert_one,
  "condiment": svg_condiment,
  "content": svg_content,
  "contrail-one": svg_contrail_one,
  "convergence": svg_convergence,
  "cookie": svg_cookie,
  "copse": svg_copse,
  "corben": svg_corben,
  "corinthia": svg_corinthia,
  "cormorant-garamond": svg_cormorant_garamond,
  "cormorant-infant": svg_cormorant_infant,
  "cormorant-sc": svg_cormorant_sc,
  "cormorant-unicase": svg_cormorant_unicase,
  "cormorant-upright": svg_cormorant_upright,
  "cormorant": svg_cormorant,
  "courgette": svg_courgette,
  "courier-prime": svg_courier_prime,
  "cousine": svg_cousine,
  "coustard": svg_coustard,
  "covered-by-your-grace": svg_covered_by_your_grace,
  "crafty-girls": svg_crafty_girls,
  "creepster": svg_creepster,
  "crete-round": svg_crete_round,
  "crimson-pro": svg_crimson_pro,
  "crimson-text": svg_crimson_text,
  "croissant-one": svg_croissant_one,
  "crushed": svg_crushed,
  "cuprum": svg_cuprum,
  "cute-font": svg_cute_font,
  "cutive-mono": svg_cutive_mono,
  "cutive": svg_cutive,
  "dai-banna-sil": svg_dai_banna_sil,
  "damion": svg_damion,
  "dancing-script": svg_dancing_script,
  "dangrek": svg_dangrek,
  "darker-grotesque": svg_darker_grotesque,
  "darumadrop-one": svg_darumadrop_one,
  "david-libre": svg_david_libre,
  "dawning-of-a-new-day": svg_dawning_of_a_new_day,
  "days-one": svg_days_one,
  "dekko": svg_dekko,
  "dela-gothic-one": svg_dela_gothic_one,
  "delicious-handrawn": svg_delicious_handrawn,
  "delius-swash-caps": svg_delius_swash_caps,
  "delius-unicase": svg_delius_unicase,
  "delius": svg_delius,
  "della-respira": svg_della_respira,
  "denk-one": svg_denk_one,
  "devonshire": svg_devonshire,
  "dhurjati": svg_dhurjati,
  "didact-gothic": svg_didact_gothic,
  "diphylleia": svg_diphylleia,
  "diplomata-sc": svg_diplomata_sc,
  "diplomata": svg_diplomata,
  "dm-mono": svg_dm_mono,
  "dm-sans": svg_dm_sans,
  "dm-serif-display": svg_dm_serif_display,
  "dm-serif-text": svg_dm_serif_text,
  "do-hyeon": svg_do_hyeon,
  "dokdo": svg_dokdo,
  "domine": svg_domine,
  "donegal-one": svg_donegal_one,
  "dongle": svg_dongle,
  "doppio-one": svg_doppio_one,
  "dorsa": svg_dorsa,
  "dosis": svg_dosis,
  "dotgothic16": svg_dotgothic16,
  "dr-sugiyama": svg_dr_sugiyama,
  "duru-sans": svg_duru_sans,
  "dynalight": svg_dynalight,
  "dynapuff": svg_dynapuff,
  "eagle-lake": svg_eagle_lake,
  "east-sea-dokdo": svg_east_sea_dokdo,
  "eater": svg_eater,
  "eb-garamond": svg_eb_garamond,
  "economica": svg_economica,
  "eczar": svg_eczar,
  "edu-nsw-act-foundation": svg_edu_nsw_act_foundation,
  "edu-qld-beginner": svg_edu_qld_beginner,
  "edu-sa-beginner": svg_edu_sa_beginner,
  "edu-tas-beginner": svg_edu_tas_beginner,
  "edu-vic-wa-nt-beginner": svg_edu_vic_wa_nt_beginner,
  "el-messiri": svg_el_messiri,
  "electrolize": svg_electrolize,
  "elsie-swash-caps": svg_elsie_swash_caps,
  "elsie": svg_elsie,
  "emblema-one": svg_emblema_one,
  "emilys-candy": svg_emilys_candy,
  "encode-sans-condensed": svg_encode_sans_condensed,
  "encode-sans-expanded": svg_encode_sans_expanded,
  "encode-sans-sc": svg_encode_sans_sc,
  "encode-sans-semi-condensed": svg_encode_sans_semi_condensed,
  "encode-sans-semi-expanded": svg_encode_sans_semi_expanded,
  "encode-sans": svg_encode_sans,
  "engagement": svg_engagement,
  "englebert": svg_englebert,
  "enriqueta": svg_enriqueta,
  "ephesis": svg_ephesis,
  "epilogue": svg_epilogue,
  "erica-one": svg_erica_one,
  "esteban": svg_esteban,
  "estonia": svg_estonia,
  "euphoria-script": svg_euphoria_script,
  "ewert": svg_ewert,
  "exo-2": svg_exo_2,
  "exo": svg_exo,
  "expletus-sans": svg_expletus_sans,
  "explora": svg_explora,
  "fahkwang": svg_fahkwang,
  "familjen-grotesk": svg_familjen_grotesk,
  "fanwood-text": svg_fanwood_text,
  "farro": svg_farro,
  "farsan": svg_farsan,
  "fascinate-inline": svg_fascinate_inline,
  "fascinate": svg_fascinate,
  "faster-one": svg_faster_one,
  "fasthand": svg_fasthand,
  "fauna-one": svg_fauna_one,
  "faustina": svg_faustina,
  "federant": svg_federant,
  "federo": svg_federo,
  "felipa": svg_felipa,
  "fenix": svg_fenix,
  "festive": svg_festive,
  "figtree": svg_figtree,
  "finger-paint": svg_finger_paint,
  "finlandica": svg_finlandica,
  "fira-code": svg_fira_code,
  "fira-mono": svg_fira_mono,
  "fira-sans-condensed": svg_fira_sans_condensed,
  "fira-sans-extra-condensed": svg_fira_sans_extra_condensed,
  "fira-sans": svg_fira_sans,
  "fjalla-one": svg_fjalla_one,
  "fjord-one": svg_fjord_one,
  "flamenco": svg_flamenco,
  "flavors": svg_flavors,
  "fleur-de-leah": svg_fleur_de_leah,
  "flow-block": svg_flow_block,
  "flow-circular": svg_flow_circular,
  "flow-rounded": svg_flow_rounded,
  "foldit": svg_foldit,
  "fondamento": svg_fondamento,
  "fontdiner-swanky": svg_fontdiner_swanky,
  "forum": svg_forum,
  "fragment-mono": svg_fragment_mono,
  "francois-one": svg_francois_one,
  "frank-ruhl-libre": svg_frank_ruhl_libre,
  "fraunces": svg_fraunces,
  "freckle-face": svg_freckle_face,
  "fredericka-the-great": svg_fredericka_the_great,
  "fredoka": svg_fredoka,
  "freehand": svg_freehand,
  "fresca": svg_fresca,
  "frijole": svg_frijole,
  "fruktur": svg_fruktur,
  "fugaz-one": svg_fugaz_one,
  "fuggles": svg_fuggles,
  "fuzzy-bubbles": svg_fuzzy_bubbles,
  "gabarito": svg_gabarito,
  "gabriela": svg_gabriela,
  "gaegu": svg_gaegu,
  "gafata": svg_gafata,
  "gajraj-one": svg_gajraj_one,
  "galada": svg_galada,
  "galdeano": svg_galdeano,
  "galindo": svg_galindo,
  "gamja-flower": svg_gamja_flower,
  "gantari": svg_gantari,
  "gasoek-one": svg_gasoek_one,
  "gayathri": svg_gayathri,
  "gelasio": svg_gelasio,
  "gemunu-libre": svg_gemunu_libre,
  "genos": svg_genos,
  "gentium-book-plus": svg_gentium_book_plus,
  "gentium-plus": svg_gentium_plus,
  "geo": svg_geo,
  "geologica": svg_geologica,
  "georama": svg_georama,
  "geostar-fill": svg_geostar_fill,
  "geostar": svg_geostar,
  "germania-one": svg_germania_one,
  "gfs-didot": svg_gfs_didot,
  "gfs-neohellenic": svg_gfs_neohellenic,
  "gideon-roman": svg_gideon_roman,
  "gidugu": svg_gidugu,
  "gilda-display": svg_gilda_display,
  "girassol": svg_girassol,
  "give-you-glory": svg_give_you_glory,
  "glass-antiqua": svg_glass_antiqua,
  "glegoo": svg_glegoo,
  "gloock": svg_gloock,
  "gloria-hallelujah": svg_gloria_hallelujah,
  "glory": svg_glory,
  "gluten": svg_gluten,
  "goblin-one": svg_goblin_one,
  "gochi-hand": svg_gochi_hand,
  "goldman": svg_goldman,
  "golos-text": svg_golos_text,
  "gorditas": svg_gorditas,
  "gothic-a1": svg_gothic_a1,
  "gotu": svg_gotu,
  "goudy-bookletter-1911": svg_goudy_bookletter_1911,
  "gowun-batang": svg_gowun_batang,
  "gowun-dodum": svg_gowun_dodum,
  "graduate": svg_graduate,
  "grand-hotel": svg_grand_hotel,
  "grandiflora-one": svg_grandiflora_one,
  "grandstander": svg_grandstander,
  "grape-nuts": svg_grape_nuts,
  "gravitas-one": svg_gravitas_one,
  "great-vibes": svg_great_vibes,
  "grechen-fuemen": svg_grechen_fuemen,
  "grenze-gotisch": svg_grenze_gotisch,
  "grenze": svg_grenze,
  "grey-qo": svg_grey_qo,
  "griffy": svg_griffy,
  "gruppo": svg_gruppo,
  "gudea": svg_gudea,
  "gugi": svg_gugi,
  "gulzar": svg_gulzar,
  "gupter": svg_gupter,
  "gurajada": svg_gurajada,
  "gwendolyn": svg_gwendolyn,
  "habibi": svg_habibi,
  "hachi-maru-pop": svg_hachi_maru_pop,
  "hahmlet": svg_hahmlet,
  "halant": svg_halant,
  "hammersmith-one": svg_hammersmith_one,
  "hanalei-fill": svg_hanalei_fill,
  "hanalei": svg_hanalei,
  "handjet": svg_handjet,
  "handlee": svg_handlee,
  "hanken-grotesk": svg_hanken_grotesk,
  "hanuman": svg_hanuman,
  "happy-monkey": svg_happy_monkey,
  "harmattan": svg_harmattan,
  "headland-one": svg_headland_one,
  "hedvig-letters-sans": svg_hedvig_letters_sans,
  "hedvig-letters-serif": svg_hedvig_letters_serif,
  "heebo": svg_heebo,
  "henny-penny": svg_henny_penny,
  "hepta-slab": svg_hepta_slab,
  "herr-von-muellerhoff": svg_herr_von_muellerhoff,
  "hi-melody": svg_hi_melody,
  "hina-mincho": svg_hina_mincho,
  "hind-guntur": svg_hind_guntur,
  "hind-madurai": svg_hind_madurai,
  "hind-siliguri": svg_hind_siliguri,
  "hind-vadodara": svg_hind_vadodara,
  "hind": svg_hind,
  "holtwood-one-sc": svg_holtwood_one_sc,
  "homemade-apple": svg_homemade_apple,
  "homenaje": svg_homenaje,
  "hubballi": svg_hubballi,
  "hurricane": svg_hurricane,
  "ibarra-real-nova": svg_ibarra_real_nova,
  "ibm-plex-mono": svg_ibm_plex_mono,
  "ibm-plex-sans-arabic": svg_ibm_plex_sans_arabic,
  "ibm-plex-sans-condensed": svg_ibm_plex_sans_condensed,
  "ibm-plex-sans-devanagari": svg_ibm_plex_sans_devanagari,
  "ibm-plex-sans-hebrew": svg_ibm_plex_sans_hebrew,
  "ibm-plex-sans-jp": svg_ibm_plex_sans_jp,
  "ibm-plex-sans-kr": svg_ibm_plex_sans_kr,
  "ibm-plex-sans-thai-looped": svg_ibm_plex_sans_thai_looped,
  "ibm-plex-sans-thai": svg_ibm_plex_sans_thai,
  "ibm-plex-sans": svg_ibm_plex_sans,
  "ibm-plex-serif": svg_ibm_plex_serif,
  "iceberg": svg_iceberg,
  "iceland": svg_iceland,
  "im-fell-double-pica-sc": svg_im_fell_double_pica_sc,
  "im-fell-double-pica": svg_im_fell_double_pica,
  "im-fell-dw-pica-sc": svg_im_fell_dw_pica_sc,
  "im-fell-dw-pica": svg_im_fell_dw_pica,
  "im-fell-english-sc": svg_im_fell_english_sc,
  "im-fell-english": svg_im_fell_english,
  "im-fell-french-canon-sc": svg_im_fell_french_canon_sc,
  "im-fell-french-canon": svg_im_fell_french_canon,
  "im-fell-great-primer-sc": svg_im_fell_great_primer_sc,
  "im-fell-great-primer": svg_im_fell_great_primer,
  "imbue": svg_imbue,
  "imperial-script": svg_imperial_script,
  "imprima": svg_imprima,
  "inclusive-sans": svg_inclusive_sans,
  "inconsolata": svg_inconsolata,
  "inder": svg_inder,
  "indie-flower": svg_indie_flower,
  "ingrid-darling": svg_ingrid_darling,
  "inika": svg_inika,
  "inknut-antiqua": svg_inknut_antiqua,
  "inria-sans": svg_inria_sans,
  "inria-serif": svg_inria_serif,
  "inspiration": svg_inspiration,
  "instrument-sans": svg_instrument_sans,
  "instrument-serif": svg_instrument_serif,
  "inter-tight": svg_inter_tight,
  "inter": svg_inter,
  "irish-grover": svg_irish_grover,
  "island-moments": svg_island_moments,
  "istok-web": svg_istok_web,
  "italiana": svg_italiana,
  "italianno": svg_italianno,
  "itim": svg_itim,
  "jacques-francois-shadow": svg_jacques_francois_shadow,
  "jacques-francois": svg_jacques_francois,
  "jaldi": svg_jaldi,
  "jetbrains-mono": svg_jetbrains_mono,
  "jim-nightshade": svg_jim_nightshade,
  "joan": svg_joan,
  "jockey-one": svg_jockey_one,
  "jolly-lodger": svg_jolly_lodger,
  "jomhuria": svg_jomhuria,
  "jomolhari": svg_jomolhari,
  "josefin-sans": svg_josefin_sans,
  "josefin-slab": svg_josefin_slab,
  "jost": svg_jost,
  "joti-one": svg_joti_one,
  "jua": svg_jua,
  "judson": svg_judson,
  "julee": svg_julee,
  "julius-sans-one": svg_julius_sans_one,
  "junge": svg_junge,
  "jura": svg_jura,
  "just-another-hand": svg_just_another_hand,
  "just-me-again-down-here": svg_just_me_again_down_here,
  "k2d": svg_k2d,
  "kablammo": svg_kablammo,
  "kadwa": svg_kadwa,
  "kaisei-decol": svg_kaisei_decol,
  "kaisei-harunoumi": svg_kaisei_harunoumi,
  "kaisei-opti": svg_kaisei_opti,
  "kaisei-tokumin": svg_kaisei_tokumin,
  "kalam": svg_kalam,
  "kalnia": svg_kalnia,
  "kameron": svg_kameron,
  "kanit": svg_kanit,
  "kantumruy-pro": svg_kantumruy_pro,
  "karantina": svg_karantina,
  "karla": svg_karla,
  "karma": svg_karma,
  "katibeh": svg_katibeh,
  "kaushan-script": svg_kaushan_script,
  "kavivanar": svg_kavivanar,
  "kavoon": svg_kavoon,
  "kay-pho-du": svg_kay_pho_du,
  "kdam-thmor-pro": svg_kdam_thmor_pro,
  "keania-one": svg_keania_one,
  "kelly-slab": svg_kelly_slab,
  "kenia": svg_kenia,
  "khand": svg_khand,
  "khmer": svg_khmer,
  "khula": svg_khula,
  "kings": svg_kings,
  "kirang-haerang": svg_kirang_haerang,
  "kite-one": svg_kite_one,
  "kiwi-maru": svg_kiwi_maru,
  "klee-one": svg_klee_one,
  "knewave": svg_knewave,
  "kodchasan": svg_kodchasan,
  "koh-santepheap": svg_koh_santepheap,
  "koho": svg_koho,
  "kolker-brush": svg_kolker_brush,
  "konkhmer-sleokchher": svg_konkhmer_sleokchher,
  "kosugi-maru": svg_kosugi_maru,
  "kosugi": svg_kosugi,
  "kotta-one": svg_kotta_one,
  "koulen": svg_koulen,
  "kranky": svg_kranky,
  "kreon": svg_kreon,
  "kristi": svg_kristi,
  "krona-one": svg_krona_one,
  "krub": svg_krub,
  "kufam": svg_kufam,
  "kulim-park": svg_kulim_park,
  "kumar-one-outline": svg_kumar_one_outline,
  "kumar-one": svg_kumar_one,
  "kumbh-sans": svg_kumbh_sans,
  "kurale": svg_kurale,
  "la-belle-aurore": svg_la_belle_aurore,
  "labrada": svg_labrada,
  "lacquer": svg_lacquer,
  "laila": svg_laila,
  "lakki-reddy": svg_lakki_reddy,
  "lalezar": svg_lalezar,
  "lancelot": svg_lancelot,
  "langar": svg_langar,
  "lateef": svg_lateef,
  "lato": svg_lato,
  "lavishly-yours": svg_lavishly_yours,
  "league-gothic": svg_league_gothic,
  "league-script": svg_league_script,
  "league-spartan": svg_league_spartan,
  "leckerli-one": svg_leckerli_one,
  "ledger": svg_ledger,
  "lekton": svg_lekton,
  "lemon": svg_lemon,
  "lemonada": svg_lemonada,
  "lexend-deca": svg_lexend_deca,
  "lexend-exa": svg_lexend_exa,
  "lexend-giga": svg_lexend_giga,
  "lexend-mega": svg_lexend_mega,
  "lexend-peta": svg_lexend_peta,
  "lexend-tera": svg_lexend_tera,
  "lexend-zetta": svg_lexend_zetta,
  "lexend": svg_lexend,
  "libre-barcode-128-text": svg_libre_barcode_128_text,
  "libre-barcode-128": svg_libre_barcode_128,
  "libre-barcode-39-extended-text": svg_libre_barcode_39_extended_text,
  "libre-barcode-39-extended": svg_libre_barcode_39_extended,
  "libre-barcode-39-text": svg_libre_barcode_39_text,
  "libre-barcode-39": svg_libre_barcode_39,
  "libre-barcode-ean13-text": svg_libre_barcode_ean13_text,
  "libre-baskerville": svg_libre_baskerville,
  "libre-bodoni": svg_libre_bodoni,
  "libre-caslon-display": svg_libre_caslon_display,
  "libre-caslon-text": svg_libre_caslon_text,
  "libre-franklin": svg_libre_franklin,
  "licorice": svg_licorice,
  "life-savers": svg_life_savers,
  "lilita-one": svg_lilita_one,
  "lily-script-one": svg_lily_script_one,
  "limelight": svg_limelight,
  "linden-hill": svg_linden_hill,
  "linefont": svg_linefont,
  "lisu-bosa": svg_lisu_bosa,
  "literata": svg_literata,
  "liu-jian-mao-cao": svg_liu_jian_mao_cao,
  "livvic": svg_livvic,
  "lobster-two": svg_lobster_two,
  "lobster": svg_lobster,
  "londrina-outline": svg_londrina_outline,
  "londrina-shadow": svg_londrina_shadow,
  "londrina-sketch": svg_londrina_sketch,
  "londrina-solid": svg_londrina_solid,
  "long-cang": svg_long_cang,
  "lora": svg_lora,
  "love-light": svg_love_light,
  "love-ya-like-a-sister": svg_love_ya_like_a_sister,
  "loved-by-the-king": svg_loved_by_the_king,
  "lovers-quarrel": svg_lovers_quarrel,
  "luckiest-guy": svg_luckiest_guy,
  "lugrasimo": svg_lugrasimo,
  "lumanosimo": svg_lumanosimo,
  "lunasima": svg_lunasima,
  "lusitana": svg_lusitana,
  "lustria": svg_lustria,
  "luxurious-roman": svg_luxurious_roman,
  "luxurious-script": svg_luxurious_script,
  "m-plus-1-code": svg_m_plus_1_code,
  "m-plus-1": svg_m_plus_1,
  "m-plus-1p": svg_m_plus_1p,
  "m-plus-2": svg_m_plus_2,
  "m-plus-code-latin": svg_m_plus_code_latin,
  "m-plus-rounded-1c": svg_m_plus_rounded_1c,
  "ma-shan-zheng": svg_ma_shan_zheng,
  "macondo-swash-caps": svg_macondo_swash_caps,
  "macondo": svg_macondo,
  "mada": svg_mada,
  "magra": svg_magra,
  "maiden-orange": svg_maiden_orange,
  "maitree": svg_maitree,
  "major-mono-display": svg_major_mono_display,
  "mako": svg_mako,
  "mali": svg_mali,
  "mallanna": svg_mallanna,
  "mandali": svg_mandali,
  "manjari": svg_manjari,
  "manrope": svg_manrope,
  "mansalva": svg_mansalva,
  "manuale": svg_manuale,
  "marcellus-sc": svg_marcellus_sc,
  "marcellus": svg_marcellus,
  "marck-script": svg_marck_script,
  "margarine": svg_margarine,
  "marhey": svg_marhey,
  "markazi-text": svg_markazi_text,
  "marko-one": svg_marko_one,
  "marmelad": svg_marmelad,
  "martel-sans": svg_martel_sans,
  "martel": svg_martel,
  "martian-mono": svg_martian_mono,
  "marvel": svg_marvel,
  "mate-sc": svg_mate_sc,
  "mate": svg_mate,
  "material-icons-outlined": svg_material_icons_outlined,
  "material-icons-round": svg_material_icons_round,
  "material-icons-sharp": svg_material_icons_sharp,
  "material-icons-two-tone": svg_material_icons_two_tone,
  "material-icons": svg_material_icons,
  "material-symbols-outlined": svg_material_symbols_outlined,
  "material-symbols-rounded": svg_material_symbols_rounded,
  "material-symbols-sharp": svg_material_symbols_sharp,
  "maven-pro": svg_maven_pro,
  "mclaren": svg_mclaren,
  "mea-culpa": svg_mea_culpa,
  "meddon": svg_meddon,
  "medievalsharp": svg_medievalsharp,
  "medula-one": svg_medula_one,
  "meera-inimai": svg_meera_inimai,
  "megrim": svg_megrim,
  "meie-script": svg_meie_script,
  "meow-script": svg_meow_script,
  "merienda": svg_merienda,
  "merriweather-sans": svg_merriweather_sans,
  "merriweather": svg_merriweather,
  "metal-mania": svg_metal_mania,
  "metal": svg_metal,
  "metamorphous": svg_metamorphous,
  "metrophobic": svg_metrophobic,
  "michroma": svg_michroma,
  "milonga": svg_milonga,
  "miltonian-tattoo": svg_miltonian_tattoo,
  "miltonian": svg_miltonian,
  "mina": svg_mina,
  "mingzat": svg_mingzat,
  "miniver": svg_miniver,
  "miriam-libre": svg_miriam_libre,
  "mirza": svg_mirza,
  "miss-fajardose": svg_miss_fajardose,
  "mitr": svg_mitr,
  "mochiy-pop-one": svg_mochiy_pop_one,
  "mochiy-pop-p-one": svg_mochiy_pop_p_one,
  "modak": svg_modak,
  "modern-antiqua": svg_modern_antiqua,
  "mogra": svg_mogra,
  "mohave": svg_mohave,
  "moirai-one": svg_moirai_one,
  "molengo": svg_molengo,
  "monda": svg_monda,
  "monofett": svg_monofett,
  "monomaniac-one": svg_monomaniac_one,
  "monoton": svg_monoton,
  "monsieur-la-doulaise": svg_monsieur_la_doulaise,
  "montaga": svg_montaga,
  "montagu-slab": svg_montagu_slab,
  "montecarlo": svg_montecarlo,
  "montez": svg_montez,
  "montserrat-alternates": svg_montserrat_alternates,
  "montserrat-subrayada": svg_montserrat_subrayada,
  "montserrat": svg_montserrat,
  "moo-lah-lah": svg_moo_lah_lah,
  "mooli": svg_mooli,
  "moon-dance": svg_moon_dance,
  "moul": svg_moul,
  "moulpali": svg_moulpali,
  "mountains-of-christmas": svg_mountains_of_christmas,
  "mouse-memoirs": svg_mouse_memoirs,
  "mr-bedfort": svg_mr_bedfort,
  "mr-dafoe": svg_mr_dafoe,
  "mr-de-haviland": svg_mr_de_haviland,
  "mrs-saint-delafield": svg_mrs_saint_delafield,
  "mrs-sheppards": svg_mrs_sheppards,
  "ms-madi": svg_ms_madi,
  "mukta-mahee": svg_mukta_mahee,
  "mukta-malar": svg_mukta_malar,
  "mukta-vaani": svg_mukta_vaani,
  "mukta": svg_mukta,
  "mulish": svg_mulish,
  "murecho": svg_murecho,
  "museomoderno": svg_museomoderno,
  "my-soul": svg_my_soul,
  "mynerve": svg_mynerve,
  "mystery-quest": svg_mystery_quest,
  "nabla": svg_nabla,
  "nanum-brush-script": svg_nanum_brush_script,
  "nanum-gothic-coding": svg_nanum_gothic_coding,
  "nanum-gothic": svg_nanum_gothic,
  "nanum-myeongjo": svg_nanum_myeongjo,
  "nanum-pen-script": svg_nanum_pen_script,
  "narnoor": svg_narnoor,
  "neonderthaw": svg_neonderthaw,
  "nerko-one": svg_nerko_one,
  "neucha": svg_neucha,
  "neuton": svg_neuton,
  "new-rocker": svg_new_rocker,
  "new-tegomin": svg_new_tegomin,
  "news-cycle": svg_news_cycle,
  "newsreader": svg_newsreader,
  "niconne": svg_niconne,
  "niramit": svg_niramit,
  "nixie-one": svg_nixie_one,
  "nobile": svg_nobile,
  "nokora": svg_nokora,
  "norican": svg_norican,
  "nosifer": svg_nosifer,
  "notable": svg_notable,
  "nothing-you-could-do": svg_nothing_you_could_do,
  "noticia-text": svg_noticia_text,
  "noto-color-emoji": svg_noto_color_emoji,
  "noto-emoji": svg_noto_emoji,
  "noto-kufi-arabic": svg_noto_kufi_arabic,
  "noto-music": svg_noto_music,
  "noto-naskh-arabic": svg_noto_naskh_arabic,
  "noto-nastaliq-urdu": svg_noto_nastaliq_urdu,
  "noto-rashi-hebrew": svg_noto_rashi_hebrew,
  "noto-sans-adlam-unjoined": svg_noto_sans_adlam_unjoined,
  "noto-sans-adlam": svg_noto_sans_adlam,
  "noto-sans-anatolian-hieroglyphs": svg_noto_sans_anatolian_hieroglyphs,
  "noto-sans-arabic": svg_noto_sans_arabic,
  "noto-sans-armenian": svg_noto_sans_armenian,
  "noto-sans-avestan": svg_noto_sans_avestan,
  "noto-sans-balinese": svg_noto_sans_balinese,
  "noto-sans-bamum": svg_noto_sans_bamum,
  "noto-sans-bassa-vah": svg_noto_sans_bassa_vah,
  "noto-sans-batak": svg_noto_sans_batak,
  "noto-sans-bengali": svg_noto_sans_bengali,
  "noto-sans-bhaiksuki": svg_noto_sans_bhaiksuki,
  "noto-sans-brahmi": svg_noto_sans_brahmi,
  "noto-sans-buginese": svg_noto_sans_buginese,
  "noto-sans-buhid": svg_noto_sans_buhid,
  "noto-sans-canadian-aboriginal": svg_noto_sans_canadian_aboriginal,
  "noto-sans-carian": svg_noto_sans_carian,
  "noto-sans-caucasian-albanian": svg_noto_sans_caucasian_albanian,
  "noto-sans-chakma": svg_noto_sans_chakma,
  "noto-sans-cham": svg_noto_sans_cham,
  "noto-sans-cherokee": svg_noto_sans_cherokee,
  "noto-sans-chorasmian": svg_noto_sans_chorasmian,
  "noto-sans-coptic": svg_noto_sans_coptic,
  "noto-sans-cuneiform": svg_noto_sans_cuneiform,
  "noto-sans-cypriot": svg_noto_sans_cypriot,
  "noto-sans-cypro-minoan": svg_noto_sans_cypro_minoan,
  "noto-sans-deseret": svg_noto_sans_deseret,
  "noto-sans-devanagari": svg_noto_sans_devanagari,
  "noto-sans-display": svg_noto_sans_display,
  "noto-sans-duployan": svg_noto_sans_duployan,
  "noto-sans-egyptian-hieroglyphs": svg_noto_sans_egyptian_hieroglyphs,
  "noto-sans-elbasan": svg_noto_sans_elbasan,
  "noto-sans-elymaic": svg_noto_sans_elymaic,
  "noto-sans-ethiopic": svg_noto_sans_ethiopic,
  "noto-sans-georgian": svg_noto_sans_georgian,
  "noto-sans-glagolitic": svg_noto_sans_glagolitic,
  "noto-sans-gothic": svg_noto_sans_gothic,
  "noto-sans-grantha": svg_noto_sans_grantha,
  "noto-sans-gujarati": svg_noto_sans_gujarati,
  "noto-sans-gunjala-gondi": svg_noto_sans_gunjala_gondi,
  "noto-sans-gurmukhi": svg_noto_sans_gurmukhi,
  "noto-sans-hanifi-rohingya": svg_noto_sans_hanifi_rohingya,
  "noto-sans-hanunoo": svg_noto_sans_hanunoo,
  "noto-sans-hatran": svg_noto_sans_hatran,
  "noto-sans-hebrew": svg_noto_sans_hebrew,
  "noto-sans-hk": svg_noto_sans_hk,
  "noto-sans-imperial-aramaic": svg_noto_sans_imperial_aramaic,
  "noto-sans-indic-siyaq-numbers": svg_noto_sans_indic_siyaq_numbers,
  "noto-sans-inscriptional-pahlavi": svg_noto_sans_inscriptional_pahlavi,
  "noto-sans-inscriptional-parthian": svg_noto_sans_inscriptional_parthian,
  "noto-sans-javanese": svg_noto_sans_javanese,
  "noto-sans-jp": svg_noto_sans_jp,
  "noto-sans-kaithi": svg_noto_sans_kaithi,
  "noto-sans-kannada": svg_noto_sans_kannada,
  "noto-sans-kawi": svg_noto_sans_kawi,
  "noto-sans-kayah-li": svg_noto_sans_kayah_li,
  "noto-sans-kharoshthi": svg_noto_sans_kharoshthi,
  "noto-sans-khmer": svg_noto_sans_khmer,
  "noto-sans-khojki": svg_noto_sans_khojki,
  "noto-sans-khudawadi": svg_noto_sans_khudawadi,
  "noto-sans-kr": svg_noto_sans_kr,
  "noto-sans-lao-looped": svg_noto_sans_lao_looped,
  "noto-sans-lao": svg_noto_sans_lao,
  "noto-sans-lepcha": svg_noto_sans_lepcha,
  "noto-sans-limbu": svg_noto_sans_limbu,
  "noto-sans-linear-a": svg_noto_sans_linear_a,
  "noto-sans-linear-b": svg_noto_sans_linear_b,
  "noto-sans-lisu": svg_noto_sans_lisu,
  "noto-sans-lycian": svg_noto_sans_lycian,
  "noto-sans-lydian": svg_noto_sans_lydian,
  "noto-sans-mahajani": svg_noto_sans_mahajani,
  "noto-sans-malayalam": svg_noto_sans_malayalam,
  "noto-sans-mandaic": svg_noto_sans_mandaic,
  "noto-sans-manichaean": svg_noto_sans_manichaean,
  "noto-sans-marchen": svg_noto_sans_marchen,
  "noto-sans-masaram-gondi": svg_noto_sans_masaram_gondi,
  "noto-sans-math": svg_noto_sans_math,
  "noto-sans-mayan-numerals": svg_noto_sans_mayan_numerals,
  "noto-sans-medefaidrin": svg_noto_sans_medefaidrin,
  "noto-sans-meetei-mayek": svg_noto_sans_meetei_mayek,
  "noto-sans-mende-kikakui": svg_noto_sans_mende_kikakui,
  "noto-sans-meroitic": svg_noto_sans_meroitic,
  "noto-sans-miao": svg_noto_sans_miao,
  "noto-sans-modi": svg_noto_sans_modi,
  "noto-sans-mongolian": svg_noto_sans_mongolian,
  "noto-sans-mono": svg_noto_sans_mono,
  "noto-sans-mro": svg_noto_sans_mro,
  "noto-sans-multani": svg_noto_sans_multani,
  "noto-sans-myanmar": svg_noto_sans_myanmar,
  "noto-sans-nabataean": svg_noto_sans_nabataean,
  "noto-sans-nag-mundari": svg_noto_sans_nag_mundari,
  "noto-sans-nandinagari": svg_noto_sans_nandinagari,
  "noto-sans-new-tai-lue": svg_noto_sans_new_tai_lue,
  "noto-sans-newa": svg_noto_sans_newa,
  "noto-sans-nko-unjoined": svg_noto_sans_nko_unjoined,
  "noto-sans-nko": svg_noto_sans_nko,
  "noto-sans-nushu": svg_noto_sans_nushu,
  "noto-sans-ogham": svg_noto_sans_ogham,
  "noto-sans-ol-chiki": svg_noto_sans_ol_chiki,
  "noto-sans-old-hungarian": svg_noto_sans_old_hungarian,
  "noto-sans-old-italic": svg_noto_sans_old_italic,
  "noto-sans-old-north-arabian": svg_noto_sans_old_north_arabian,
  "noto-sans-old-permic": svg_noto_sans_old_permic,
  "noto-sans-old-persian": svg_noto_sans_old_persian,
  "noto-sans-old-sogdian": svg_noto_sans_old_sogdian,
  "noto-sans-old-south-arabian": svg_noto_sans_old_south_arabian,
  "noto-sans-old-turkic": svg_noto_sans_old_turkic,
  "noto-sans-oriya": svg_noto_sans_oriya,
  "noto-sans-osage": svg_noto_sans_osage,
  "noto-sans-osmanya": svg_noto_sans_osmanya,
  "noto-sans-pahawh-hmong": svg_noto_sans_pahawh_hmong,
  "noto-sans-palmyrene": svg_noto_sans_palmyrene,
  "noto-sans-pau-cin-hau": svg_noto_sans_pau_cin_hau,
  "noto-sans-phags-pa": svg_noto_sans_phags_pa,
  "noto-sans-phoenician": svg_noto_sans_phoenician,
  "noto-sans-psalter-pahlavi": svg_noto_sans_psalter_pahlavi,
  "noto-sans-rejang": svg_noto_sans_rejang,
  "noto-sans-runic": svg_noto_sans_runic,
  "noto-sans-samaritan": svg_noto_sans_samaritan,
  "noto-sans-saurashtra": svg_noto_sans_saurashtra,
  "noto-sans-sc": svg_noto_sans_sc,
  "noto-sans-sharada": svg_noto_sans_sharada,
  "noto-sans-shavian": svg_noto_sans_shavian,
  "noto-sans-siddham": svg_noto_sans_siddham,
  "noto-sans-signwriting": svg_noto_sans_signwriting,
  "noto-sans-sinhala": svg_noto_sans_sinhala,
  "noto-sans-sogdian": svg_noto_sans_sogdian,
  "noto-sans-sora-sompeng": svg_noto_sans_sora_sompeng,
  "noto-sans-soyombo": svg_noto_sans_soyombo,
  "noto-sans-sundanese": svg_noto_sans_sundanese,
  "noto-sans-syloti-nagri": svg_noto_sans_syloti_nagri,
  "noto-sans-symbols-2": svg_noto_sans_symbols_2,
  "noto-sans-symbols": svg_noto_sans_symbols,
  "noto-sans-syriac-eastern": svg_noto_sans_syriac_eastern,
  "noto-sans-syriac": svg_noto_sans_syriac,
  "noto-sans-tagalog": svg_noto_sans_tagalog,
  "noto-sans-tagbanwa": svg_noto_sans_tagbanwa,
  "noto-sans-tai-le": svg_noto_sans_tai_le,
  "noto-sans-tai-tham": svg_noto_sans_tai_tham,
  "noto-sans-tai-viet": svg_noto_sans_tai_viet,
  "noto-sans-takri": svg_noto_sans_takri,
  "noto-sans-tamil-supplement": svg_noto_sans_tamil_supplement,
  "noto-sans-tamil": svg_noto_sans_tamil,
  "noto-sans-tangsa": svg_noto_sans_tangsa,
  "noto-sans-tc": svg_noto_sans_tc,
  "noto-sans-telugu": svg_noto_sans_telugu,
  "noto-sans-thaana": svg_noto_sans_thaana,
  "noto-sans-thai-looped": svg_noto_sans_thai_looped,
  "noto-sans-thai": svg_noto_sans_thai,
  "noto-sans-tifinagh": svg_noto_sans_tifinagh,
  "noto-sans-tirhuta": svg_noto_sans_tirhuta,
  "noto-sans-ugaritic": svg_noto_sans_ugaritic,
  "noto-sans-vai": svg_noto_sans_vai,
  "noto-sans-vithkuqi": svg_noto_sans_vithkuqi,
  "noto-sans-wancho": svg_noto_sans_wancho,
  "noto-sans-warang-citi": svg_noto_sans_warang_citi,
  "noto-sans-yi": svg_noto_sans_yi,
  "noto-sans-zanabazar-square": svg_noto_sans_zanabazar_square,
  "noto-sans": svg_noto_sans,
  "noto-serif-ahom": svg_noto_serif_ahom,
  "noto-serif-armenian": svg_noto_serif_armenian,
  "noto-serif-balinese": svg_noto_serif_balinese,
  "noto-serif-bengali": svg_noto_serif_bengali,
  "noto-serif-devanagari": svg_noto_serif_devanagari,
  "noto-serif-display": svg_noto_serif_display,
  "noto-serif-dogra": svg_noto_serif_dogra,
  "noto-serif-ethiopic": svg_noto_serif_ethiopic,
  "noto-serif-georgian": svg_noto_serif_georgian,
  "noto-serif-grantha": svg_noto_serif_grantha,
  "noto-serif-gujarati": svg_noto_serif_gujarati,
  "noto-serif-gurmukhi": svg_noto_serif_gurmukhi,
  "noto-serif-hebrew": svg_noto_serif_hebrew,
  "noto-serif-hk": svg_noto_serif_hk,
  "noto-serif-jp": svg_noto_serif_jp,
  "noto-serif-kannada": svg_noto_serif_kannada,
  "noto-serif-khitan-small-script": svg_noto_serif_khitan_small_script,
  "noto-serif-khmer": svg_noto_serif_khmer,
  "noto-serif-khojki": svg_noto_serif_khojki,
  "noto-serif-kr": svg_noto_serif_kr,
  "noto-serif-lao": svg_noto_serif_lao,
  "noto-serif-makasar": svg_noto_serif_makasar,
  "noto-serif-malayalam": svg_noto_serif_malayalam,
  "noto-serif-myanmar": svg_noto_serif_myanmar,
  "noto-serif-np-hmong": svg_noto_serif_np_hmong,
  "noto-serif-old-uyghur": svg_noto_serif_old_uyghur,
  "noto-serif-oriya": svg_noto_serif_oriya,
  "noto-serif-ottoman-siyaq": svg_noto_serif_ottoman_siyaq,
  "noto-serif-sc": svg_noto_serif_sc,
  "noto-serif-sinhala": svg_noto_serif_sinhala,
  "noto-serif-tamil": svg_noto_serif_tamil,
  "noto-serif-tangut": svg_noto_serif_tangut,
  "noto-serif-tc": svg_noto_serif_tc,
  "noto-serif-telugu": svg_noto_serif_telugu,
  "noto-serif-thai": svg_noto_serif_thai,
  "noto-serif-tibetan": svg_noto_serif_tibetan,
  "noto-serif-toto": svg_noto_serif_toto,
  "noto-serif-vithkuqi": svg_noto_serif_vithkuqi,
  "noto-serif-yezidi": svg_noto_serif_yezidi,
  "noto-serif": svg_noto_serif,
  "noto-traditional-nushu": svg_noto_traditional_nushu,
  "nova-cut": svg_nova_cut,
  "nova-flat": svg_nova_flat,
  "nova-mono": svg_nova_mono,
  "nova-oval": svg_nova_oval,
  "nova-round": svg_nova_round,
  "nova-script": svg_nova_script,
  "nova-slim": svg_nova_slim,
  "nova-square": svg_nova_square,
  "ntr": svg_ntr,
  "numans": svg_numans,
  "nunito-sans": svg_nunito_sans,
  "nunito": svg_nunito,
  "nuosu-sil": svg_nuosu_sil,
  "odibee-sans": svg_odibee_sans,
  "odor-mean-chey": svg_odor_mean_chey,
  "offside": svg_offside,
  "oi": svg_oi,
  "old-standard-tt": svg_old_standard_tt,
  "oldenburg": svg_oldenburg,
  "ole": svg_ole,
  "oleo-script-swash-caps": svg_oleo_script_swash_caps,
  "oleo-script": svg_oleo_script,
  "onest": svg_onest,
  "oooh-baby": svg_oooh_baby,
  "open-sans": svg_open_sans,
  "oranienbaum": svg_oranienbaum,
  "orbit": svg_orbit,
  "orbitron": svg_orbitron,
  "oregano": svg_oregano,
  "orelega-one": svg_orelega_one,
  "orienta": svg_orienta,
  "original-surfer": svg_original_surfer,
  "oswald": svg_oswald,
  "outfit": svg_outfit,
  "over-the-rainbow": svg_over_the_rainbow,
  "overlock-sc": svg_overlock_sc,
  "overlock": svg_overlock,
  "overpass-mono": svg_overpass_mono,
  "overpass": svg_overpass,
  "ovo": svg_ovo,
  "oxanium": svg_oxanium,
  "oxygen-mono": svg_oxygen_mono,
  "oxygen": svg_oxygen,
  "pacifico": svg_pacifico,
  "padauk": svg_padauk,
  "padyakke-expanded-one": svg_padyakke_expanded_one,
  "palanquin-dark": svg_palanquin_dark,
  "palanquin": svg_palanquin,
  "palette-mosaic": svg_palette_mosaic,
  "pangolin": svg_pangolin,
  "paprika": svg_paprika,
  "parisienne": svg_parisienne,
  "passero-one": svg_passero_one,
  "passion-one": svg_passion_one,
  "passions-conflict": svg_passions_conflict,
  "pathway-extreme": svg_pathway_extreme,
  "pathway-gothic-one": svg_pathway_gothic_one,
  "patrick-hand-sc": svg_patrick_hand_sc,
  "patrick-hand": svg_patrick_hand,
  "pattaya": svg_pattaya,
  "patua-one": svg_patua_one,
  "pavanam": svg_pavanam,
  "paytone-one": svg_paytone_one,
  "peddana": svg_peddana,
  "peralta": svg_peralta,
  "permanent-marker": svg_permanent_marker,
  "petemoss": svg_petemoss,
  "petit-formal-script": svg_petit_formal_script,
  "petrona": svg_petrona,
  "philosopher": svg_philosopher,
  "phudu": svg_phudu,
  "piazzolla": svg_piazzolla,
  "piedra": svg_piedra,
  "pinyon-script": svg_pinyon_script,
  "pirata-one": svg_pirata_one,
  "pixelify-sans": svg_pixelify_sans,
  "plaster": svg_plaster,
  "play": svg_play,
  "playball": svg_playball,
  "playfair-display-sc": svg_playfair_display_sc,
  "playfair-display": svg_playfair_display,
  "playfair": svg_playfair,
  "playpen-sans": svg_playpen_sans,
  "plus-jakarta-sans": svg_plus_jakarta_sans,
  "podkova": svg_podkova,
  "poiret-one": svg_poiret_one,
  "poller-one": svg_poller_one,
  "poltawski-nowy": svg_poltawski_nowy,
  "poly": svg_poly,
  "pompiere": svg_pompiere,
  "pontano-sans": svg_pontano_sans,
  "poor-story": svg_poor_story,
  "poppins": svg_poppins,
  "port-lligat-sans": svg_port_lligat_sans,
  "port-lligat-slab": svg_port_lligat_slab,
  "potta-one": svg_potta_one,
  "pragati-narrow": svg_pragati_narrow,
  "praise": svg_praise,
  "prata": svg_prata,
  "preahvihear": svg_preahvihear,
  "press-start-2p": svg_press_start_2p,
  "pridi": svg_pridi,
  "princess-sofia": svg_princess_sofia,
  "prociono": svg_prociono,
  "prompt": svg_prompt,
  "prosto-one": svg_prosto_one,
  "proza-libre": svg_proza_libre,
  "pt-mono": svg_pt_mono,
  "pt-sans-caption": svg_pt_sans_caption,
  "pt-sans-narrow": svg_pt_sans_narrow,
  "pt-sans": svg_pt_sans,
  "pt-serif-caption": svg_pt_serif_caption,
  "pt-serif": svg_pt_serif,
  "public-sans": svg_public_sans,
  "puppies-play": svg_puppies_play,
  "puritan": svg_puritan,
  "purple-purse": svg_purple_purse,
  "qahiri": svg_qahiri,
  "quando": svg_quando,
  "quantico": svg_quantico,
  "quattrocento-sans": svg_quattrocento_sans,
  "quattrocento": svg_quattrocento,
  "questrial": svg_questrial,
  "quicksand": svg_quicksand,
  "quintessential": svg_quintessential,
  "qwigley": svg_qwigley,
  "qwitcher-grypen": svg_qwitcher_grypen,
  "racing-sans-one": svg_racing_sans_one,
  "radio-canada": svg_radio_canada,
  "radley": svg_radley,
  "rajdhani": svg_rajdhani,
  "rakkas": svg_rakkas,
  "raleway-dots": svg_raleway_dots,
  "raleway": svg_raleway,
  "ramabhadra": svg_ramabhadra,
  "ramaraja": svg_ramaraja,
  "rambla": svg_rambla,
  "rammetto-one": svg_rammetto_one,
  "rampart-one": svg_rampart_one,
  "ranchers": svg_ranchers,
  "rancho": svg_rancho,
  "ranga": svg_ranga,
  "rasa": svg_rasa,
  "rationale": svg_rationale,
  "ravi-prakash": svg_ravi_prakash,
  "readex-pro": svg_readex_pro,
  "recursive": svg_recursive,
  "red-hat-display": svg_red_hat_display,
  "red-hat-mono": svg_red_hat_mono,
  "red-hat-text": svg_red_hat_text,
  "red-rose": svg_red_rose,
  "redacted-script": svg_redacted_script,
  "redacted": svg_redacted,
  "redressed": svg_redressed,
  "reem-kufi-fun": svg_reem_kufi_fun,
  "reem-kufi-ink": svg_reem_kufi_ink,
  "reem-kufi": svg_reem_kufi,
  "reenie-beanie": svg_reenie_beanie,
  "reggae-one": svg_reggae_one,
  "rem": svg_rem,
  "rethink-sans": svg_rethink_sans,
  "revalia": svg_revalia,
  "rhodium-libre": svg_rhodium_libre,
  "ribeye-marrow": svg_ribeye_marrow,
  "ribeye": svg_ribeye,
  "righteous": svg_righteous,
  "risque": svg_risque,
  "road-rage": svg_road_rage,
  "roboto-condensed": svg_roboto_condensed,
  "roboto-flex": svg_roboto_flex,
  "roboto-mono": svg_roboto_mono,
  "roboto-serif": svg_roboto_serif,
  "roboto-slab": svg_roboto_slab,
  "roboto": svg_roboto,
  "rochester": svg_rochester,
  "rock-3d": svg_rock_3d,
  "rock-salt": svg_rock_salt,
  "rocknroll-one": svg_rocknroll_one,
  "rokkitt": svg_rokkitt,
  "romanesco": svg_romanesco,
  "ropa-sans": svg_ropa_sans,
  "rosario": svg_rosario,
  "rosarivo": svg_rosarivo,
  "rouge-script": svg_rouge_script,
  "rowdies": svg_rowdies,
  "rozha-one": svg_rozha_one,
  "rubik-80s-fade": svg_rubik_80s_fade,
  "rubik-beastly": svg_rubik_beastly,
  "rubik-broken-fax": svg_rubik_broken_fax,
  "rubik-bubbles": svg_rubik_bubbles,
  "rubik-burned": svg_rubik_burned,
  "rubik-dirt": svg_rubik_dirt,
  "rubik-distressed": svg_rubik_distressed,
  "rubik-doodle-shadow": svg_rubik_doodle_shadow,
  "rubik-doodle-triangles": svg_rubik_doodle_triangles,
  "rubik-gemstones": svg_rubik_gemstones,
  "rubik-glitch": svg_rubik_glitch,
  "rubik-iso": svg_rubik_iso,
  "rubik-lines": svg_rubik_lines,
  "rubik-maps": svg_rubik_maps,
  "rubik-marker-hatch": svg_rubik_marker_hatch,
  "rubik-maze": svg_rubik_maze,
  "rubik-microbe": svg_rubik_microbe,
  "rubik-mono-one": svg_rubik_mono_one,
  "rubik-moonrocks": svg_rubik_moonrocks,
  "rubik-pixels": svg_rubik_pixels,
  "rubik-puddles": svg_rubik_puddles,
  "rubik-scribble": svg_rubik_scribble,
  "rubik-spray-paint": svg_rubik_spray_paint,
  "rubik-storm": svg_rubik_storm,
  "rubik-vinyl": svg_rubik_vinyl,
  "rubik-wet-paint": svg_rubik_wet_paint,
  "rubik": svg_rubik,
  "ruda": svg_ruda,
  "rufina": svg_rufina,
  "ruge-boogie": svg_ruge_boogie,
  "ruluko": svg_ruluko,
  "rum-raisin": svg_rum_raisin,
  "ruslan-display": svg_ruslan_display,
  "russo-one": svg_russo_one,
  "ruthie": svg_ruthie,
  "ruwudu": svg_ruwudu,
  "rye": svg_rye,
  "sacramento": svg_sacramento,
  "sahitya": svg_sahitya,
  "sail": svg_sail,
  "saira-condensed": svg_saira_condensed,
  "saira-extra-condensed": svg_saira_extra_condensed,
  "saira-semi-condensed": svg_saira_semi_condensed,
  "saira-stencil-one": svg_saira_stencil_one,
  "saira": svg_saira,
  "salsa": svg_salsa,
  "sanchez": svg_sanchez,
  "sancreek": svg_sancreek,
  "sansita-swashed": svg_sansita_swashed,
  "sansita": svg_sansita,
  "sarabun": svg_sarabun,
  "sarala": svg_sarala,
  "sarina": svg_sarina,
  "sarpanch": svg_sarpanch,
  "sassy-frass": svg_sassy_frass,
  "satisfy": svg_satisfy,
  "sawarabi-gothic": svg_sawarabi_gothic,
  "sawarabi-mincho": svg_sawarabi_mincho,
  "scada": svg_scada,
  "scheherazade-new": svg_scheherazade_new,
  "schibsted-grotesk": svg_schibsted_grotesk,
  "schoolbell": svg_schoolbell,
  "scope-one": svg_scope_one,
  "seaweed-script": svg_seaweed_script,
  "secular-one": svg_secular_one,
  "sedgwick-ave-display": svg_sedgwick_ave_display,
  "sedgwick-ave": svg_sedgwick_ave,
  "sen": svg_sen,
  "send-flowers": svg_send_flowers,
  "sevillana": svg_sevillana,
  "seymour-one": svg_seymour_one,
  "shadows-into-light-two": svg_shadows_into_light_two,
  "shadows-into-light": svg_shadows_into_light,
  "shalimar": svg_shalimar,
  "shantell-sans": svg_shantell_sans,
  "shanti": svg_shanti,
  "share-tech-mono": svg_share_tech_mono,
  "share-tech": svg_share_tech,
  "share": svg_share,
  "shippori-antique-b1": svg_shippori_antique_b1,
  "shippori-antique": svg_shippori_antique,
  "shippori-mincho-b1": svg_shippori_mincho_b1,
  "shippori-mincho": svg_shippori_mincho,
  "shizuru": svg_shizuru,
  "shojumaru": svg_shojumaru,
  "short-stack": svg_short_stack,
  "shrikhand": svg_shrikhand,
  "siemreap": svg_siemreap,
  "sigmar-one": svg_sigmar_one,
  "sigmar": svg_sigmar,
  "signika-negative": svg_signika_negative,
  "signika": svg_signika,
  "silkscreen": svg_silkscreen,
  "simonetta": svg_simonetta,
  "single-day": svg_single_day,
  "sintony": svg_sintony,
  "sirin-stencil": svg_sirin_stencil,
  "six-caps": svg_six_caps,
  "skranji": svg_skranji,
  "slabo-13px": svg_slabo_13px,
  "slabo-27px": svg_slabo_27px,
  "slackey": svg_slackey,
  "slackside-one": svg_slackside_one,
  "smokum": svg_smokum,
  "smooch-sans": svg_smooch_sans,
  "smooch": svg_smooch,
  "smythe": svg_smythe,
  "sniglet": svg_sniglet,
  "snippet": svg_snippet,
  "snowburst-one": svg_snowburst_one,
  "sofadi-one": svg_sofadi_one,
  "sofia-sans-condensed": svg_sofia_sans_condensed,
  "sofia-sans-extra-condensed": svg_sofia_sans_extra_condensed,
  "sofia-sans-semi-condensed": svg_sofia_sans_semi_condensed,
  "sofia-sans": svg_sofia_sans,
  "sofia": svg_sofia,
  "solitreo": svg_solitreo,
  "solway": svg_solway,
  "sometype-mono": svg_sometype_mono,
  "song-myung": svg_song_myung,
  "sono": svg_sono,
  "sonsie-one": svg_sonsie_one,
  "sora": svg_sora,
  "sorts-mill-goudy": svg_sorts_mill_goudy,
  "source-code-pro": svg_source_code_pro,
  "source-sans-3": svg_source_sans_3,
  "source-serif-4": svg_source_serif_4,
  "space-grotesk": svg_space_grotesk,
  "space-mono": svg_space_mono,
  "special-elite": svg_special_elite,
  "spectral-sc": svg_spectral_sc,
  "spectral": svg_spectral,
  "spicy-rice": svg_spicy_rice,
  "spinnaker": svg_spinnaker,
  "spirax": svg_spirax,
  "splash": svg_splash,
  "spline-sans-mono": svg_spline_sans_mono,
  "spline-sans": svg_spline_sans,
  "squada-one": svg_squada_one,
  "square-peg": svg_square_peg,
  "sree-krushnadevaraya": svg_sree_krushnadevaraya,
  "sriracha": svg_sriracha,
  "srisakdi": svg_srisakdi,
  "staatliches": svg_staatliches,
  "stalemate": svg_stalemate,
  "stalinist-one": svg_stalinist_one,
  "stardos-stencil": svg_stardos_stencil,
  "stick-no-bills": svg_stick_no_bills,
  "stick": svg_stick,
  "stint-ultra-condensed": svg_stint_ultra_condensed,
  "stint-ultra-expanded": svg_stint_ultra_expanded,
  "stix-two-text": svg_stix_two_text,
  "stoke": svg_stoke,
  "strait": svg_strait,
  "style-script": svg_style_script,
  "stylish": svg_stylish,
  "sue-ellen-francisco": svg_sue_ellen_francisco,
  "suez-one": svg_suez_one,
  "sulphur-point": svg_sulphur_point,
  "sumana": svg_sumana,
  "sunshiney": svg_sunshiney,
  "supermercado-one": svg_supermercado_one,
  "sura": svg_sura,
  "suranna": svg_suranna,
  "suravaram": svg_suravaram,
  "suwannaphum": svg_suwannaphum,
  "swanky-and-moo-moo": svg_swanky_and_moo_moo,
  "syncopate": svg_syncopate,
  "syne-mono": svg_syne_mono,
  "syne-tactile": svg_syne_tactile,
  "syne": svg_syne,
  "tai-heritage-pro": svg_tai_heritage_pro,
  "tajawal": svg_tajawal,
  "tangerine": svg_tangerine,
  "tapestry": svg_tapestry,
  "taprom": svg_taprom,
  "tauri": svg_tauri,
  "taviraj": svg_taviraj,
  "teko": svg_teko,
  "tektur": svg_tektur,
  "telex": svg_telex,
  "tenali-ramakrishna": svg_tenali_ramakrishna,
  "tenor-sans": svg_tenor_sans,
  "text-me-one": svg_text_me_one,
  "texturina": svg_texturina,
  "thasadith": svg_thasadith,
  "the-girl-next-door": svg_the_girl_next_door,
  "the-nautigal": svg_the_nautigal,
  "tienne": svg_tienne,
  "tillana": svg_tillana,
  "tilt-neon": svg_tilt_neon,
  "tilt-prism": svg_tilt_prism,
  "tilt-warp": svg_tilt_warp,
  "timmana": svg_timmana,
  "tinos": svg_tinos,
  "tiro-bangla": svg_tiro_bangla,
  "tiro-devanagari-hindi": svg_tiro_devanagari_hindi,
  "tiro-devanagari-marathi": svg_tiro_devanagari_marathi,
  "tiro-devanagari-sanskrit": svg_tiro_devanagari_sanskrit,
  "tiro-gurmukhi": svg_tiro_gurmukhi,
  "tiro-kannada": svg_tiro_kannada,
  "tiro-tamil": svg_tiro_tamil,
  "tiro-telugu": svg_tiro_telugu,
  "titan-one": svg_titan_one,
  "titillium-web": svg_titillium_web,
  "tomorrow": svg_tomorrow,
  "tourney": svg_tourney,
  "trade-winds": svg_trade_winds,
  "train-one": svg_train_one,
  "trirong": svg_trirong,
  "trispace": svg_trispace,
  "trocchi": svg_trocchi,
  "trochut": svg_trochut,
  "truculenta": svg_truculenta,
  "trykker": svg_trykker,
  "tsukimi-rounded": svg_tsukimi_rounded,
  "tulpen-one": svg_tulpen_one,
  "turret-road": svg_turret_road,
  "twinkle-star": svg_twinkle_star,
  "ubuntu-condensed": svg_ubuntu_condensed,
  "ubuntu-mono": svg_ubuntu_mono,
  "ubuntu": svg_ubuntu,
  "uchen": svg_uchen,
  "ultra": svg_ultra,
  "unbounded": svg_unbounded,
  "uncial-antiqua": svg_uncial_antiqua,
  "underdog": svg_underdog,
  "unica-one": svg_unica_one,
  "unifrakturmaguntia": svg_unifrakturmaguntia,
  "unkempt": svg_unkempt,
  "unlock": svg_unlock,
  "unna": svg_unna,
  "updock": svg_updock,
  "urbanist": svg_urbanist,
  "vampiro-one": svg_vampiro_one,
  "varela-round": svg_varela_round,
  "varela": svg_varela,
  "varta": svg_varta,
  "vast-shadow": svg_vast_shadow,
  "vazirmatn": svg_vazirmatn,
  "vesper-libre": svg_vesper_libre,
  "viaoda-libre": svg_viaoda_libre,
  "vibes": svg_vibes,
  "vibur": svg_vibur,
  "victor-mono": svg_victor_mono,
  "vidaloka": svg_vidaloka,
  "viga": svg_viga,
  "vina-sans": svg_vina_sans,
  "voces": svg_voces,
  "volkhov": svg_volkhov,
  "vollkorn-sc": svg_vollkorn_sc,
  "vollkorn": svg_vollkorn,
  "voltaire": svg_voltaire,
  "vt323": svg_vt323,
  "vujahday-script": svg_vujahday_script,
  "waiting-for-the-sunrise": svg_waiting_for_the_sunrise,
  "wallpoet": svg_wallpoet,
  "walter-turncoat": svg_walter_turncoat,
  "warnes": svg_warnes,
  "water-brush": svg_water_brush,
  "waterfall": svg_waterfall,
  "wavefont": svg_wavefont,
  "wellfleet": svg_wellfleet,
  "wendy-one": svg_wendy_one,
  "whisper": svg_whisper,
};
